/* Language pack: ru */
export const translationsRu = {
	chatDropFiles: "Перетащите файлы сюда, чтобы прикрепить",
	resumeRecording: "Продолжить",
	chatCallMissed: "Пропущен",
	chatCallDeclined: "Отклонён",
	chatAudioConference: "Аудиоконференция",
	chatVideoConference: "Видеоконференция",

	chatHistoryBeginning: "Начало переписки",
	chatHistoryEmpty: "Сообщений пока нет",
	chatHistoryLoadFailed: "Не удалось загрузить историю чата.",
	personalTime: "Предоставленные компанией часы",
	hrPersonalHoursPerYear: "Предоставляемые часы в год",
	hrPersonalHoursHint: "Годовой лимит для опозданий, ранних уходов и отсутствий. Неиспользованные часы не переносятся на следующий год.",
	absenceDays: "Дни",
	absenceHours: "Часы",
	absenceUnit: "Единица отсутствия",
	absenceRequest: "Запросить отсутствие",
	absenceRequestHint: "Выберите прошедшие или будущие даты. Баланс уменьшается после одобрения.",
	absenceRequestSaved: "Запрос отправлен на одобрение",
	absenceAvailable: "Остаток",
	absenceUsed: "Использовано / запланировано",
	sickBalanceDays: "Оставшиеся дни болезни",
	personalBalanceHours: "Оставшиеся часы компании",
	absenceBalanceHint: "Одобренные будущие отсутствия включены в использованное время. Отмена или удаление восстанавливает баланс.",

	IDCardImages: "Изображения удостоверения личности",
	IT: "ИТ",
	Status: "Статус",
	abbreviation: "Аббревиатура",
	aboutUsItems: "Элементы 'О нас'",
	absent: "Отсутствует",
	absentDays: "Дни отсутствия",
	accept: "Принять",
	actSendingDate: "Дата отправки «Акт»",
	actionTimestamp: "Временная метка действия",
	actionType: "Тип действия",
	actions: "Действия",
	activateStep7_8_9: "Задание отделу проектирования линий электропередачи ( 7, 8, 9 )",
	activateStep8: "Задание геодезическому отделу ( 8 )",
	activatedProjects: "Активированные проекты",
	active: "Активный",
	activeCarts: "Активные корзины",
	activeClients: "Активные клиенты",
	activeCustomers: "Активные клиенты",
	activeProjectSteps: "Активные шаги проекта",
	activePromos: "Активные акции",
	activeSales: "Активные продажи",
	activeSalesEvents: "Активные акции",
	activeServices: "активные сервисы",
	activeSteps: "Активные шаги",
	activeStreams: "Активные потоки",
	activeTasks: "Активные задачи",
	activeTime: "Активное время",
	activity: "Активность",
	activityTimes: "Время активности",
	activityLoadFailed: "Не удалось загрузить активность пользователя за этот день.",
	noActivityForDay: "За этот день активность не зафиксирована.",
	currentInactivity: "Текущая неактивность",
	userActivityHistory: "Активность пользователя (7 дней)",
	actualHours: "Фактические часы",
	adInterval: "Интервал рекламы",
	adIntervalOverride: "Переопределение интервала рекламы",
	adIntervalOverrideDesc: "Описание переопределения интервала рекламы",
	adIntervalOverrideValue: "Значение переопределения интервала рекламы",
	adPlaylist: "Плейлист рекламы",
	adPlaylists: "Рекламные плейлисты",
	adTracks: "Рекламные треки",
	add: "Добавить",
	addAttendance: "Добавить посещение",
	addFeature: "Добавить функцию",
	addFeatureLine: "Добавить строку функции",
	addFiles: "Добавить файлы",
	addMoreFiles: "Добавить больше файлов",
	addNew: "Добавить",
	addPriceLine: "Добавить строку цены",
	addRule: "Добавить правило",
	startChat: "Начать чат",
	addToList: "Добавить в лист",
	addVacationInterval: "Добавить период отпуска",
	added: "Добавлено",
	additionalDetails: "Дополнительные детали",
	address: "Адрес",
	addressData: "Адресные данные",
	advanceDeductions: "Удержания аванса",
	advertisement: "Реклама",
	age: "возраст",
	ageGroups: "Возрастные группы",
	ago: "назад",
	agreedProjects: "Согласованные проекты",
	agreementAquipment: "Согласование оборудования",
	aiConversations: "Разговоры",
	album: "Альбом",
	allArtists: "все исполнители",
	allAudioTracks: "все аудио треки",
	allContentItems: "все элементы контента",
	allFilesDeleted: "Все файлы были навсегда удалены",
	allFilesWillBeDeleted: "Все файлы будут удалены безвозвратно",
	allPlaylists: "все плейлисты",
	allRegisteredContacts: "все зарегистрированные клиенты",
	allTickets: "Все билеты",
	amount: "Сумма",
	analytics: "Аналитика",
	answer: "Ответ",
	apartment: "Квартира",
	apply: "Применить",
	appsMenu: "Меню приложений",
	approved: "Утверждено",
	approvedInterval: "Одобренный интервал",
	archive: "Архив",
	archived: "Архив",
	areYouSure: "Вы уверены ?",
	areYouSureToDelete: "Вы уверены, что хотите удалить это?",
	arrived: "прибыли",
	artist: "Исполнитель",
	artistObject: "Объект артиста",
	assignedTo: "Назначено",
	assignedToUser: "Назначено",
	assignmentToTheConstructionDepartment: "Предоставление задания строительному отделу",
	attach: "Прикрепить",
	attachFile: "Прикрепить файл",
	attachments: "Вложения",
	automationCenterAction: "Действие",
	automationCenterActionResults: "Результаты действий",
	automationCenterActions: "Действия",
	automationCenterActionsCount: "{count} действ.",
	automationCenterActiveRules: "Активные правила ({count})",
	automationCenterAddAction: "Добавить действие",
	automationCenterAddCondition: "Добавить условие",
	automationCenterAvailableFields: "Доступные поля: {fields}",
	automationCenterCancel: "Отмена",
	automationCenterClearFilters: "Сбросить фильтры",
	automationCenterColActions: "Действия",
	automationCenterColDuration: "Длительность",
	automationCenterColEvent: "Событие",
	automationCenterColLastRun: "Последний запуск",
	automationCenterColManage: "Управление",
	automationCenterColName: "Название",
	automationCenterColRule: "Правило",
	automationCenterColRuleActions: "Действия правила",
	automationCenterColRuleName: "Название правила",
	automationCenterColStatus: "Статус",
	automationCenterColTimestamp: "Время",
	automationCenterColTriggeredAt: "Время запуска",
	automationCenterColTrigger: "Триггер",
	automationCenterConditionsOptional: "Условия (необязательно)",
	automationCenterCreateRule: "Создать правило",
	automationCenterCreateRuleButton: "Создать правило",
	automationCenterDeleted: "Удалено",
	automationCenterDescription: "Описание",
	automationCenterDescriptionPlaceholder: "Что делает это правило?",
	automationCenterDisabled: "Отключено",
	automationCenterDomain: "Домен",
	automationCenterDomainFinance: "Финансы",
	automationCenterDomainHr: "HR",
	automationCenterDomainIt: "IT",
	automationCenterDomainTicket: "Тикеты",
	automationCenterEdit: "Изменить",
	automationCenterEditRule: "Изменить правило",
	automationCenterEnabled: "Включено",
	automationCenterError: "Ошибка",
	automationCenterEvent: "Событие",
	automationCenterExecutionLogs: "Журнал выполнения",
	automationCenterFailed: "Ошибка",
	automationCenterFailedDeleteRule: "Не удалось удалить правило",
	automationCenterField: "Поле",
	automationCenterFillRequiredFields:
		"Заполните все обязательные поля и добавьте хотя бы одно действие",
	automationCenterFilterByStatus: "Фильтр по статусу",
	automationCenterLogTitle: "Журнал: {name}",
	automationCenterNewRule: "Новое правило",
	automationCenterNoExecutionLogsYet: "Записей выполнения пока нет.",
	automationCenterNone: "нет",
	automationCenterNoLogsFound: "Записи не найдены.",
	automationCenterNoRulesYet: "Правил автоматизации пока нет. Создайте первое правило!",
	automationCenterNoUsersFound: "Пользователи не найдены",
	automationCenterNoDepartmentsFound: "Отделы не найдены",
	automationCenterSearchSelectDepartments: "Найти и выбрать отделы",
	automationCenterOperator: "Оператор",
	automationCenterOperatorContains: "содержит",
	automationCenterOperatorIn: "в списке",
	automationCenterParameters: "Параметры",
	automationCenterPartial: "Частично",
	automationCenterPriorityCritical: "Критический",
	automationCenterPriorityHigh: "Высокий",
	automationCenterPriorityLow: "Низкий",
	automationCenterPriorityMedium: "Средний",
	automationCenterRecentExecutions: "Недавние выполнения",
	automationCenterRefresh: "Обновить",
	automationCenterRuleDeletedSuccess: "Правило успешно удалено",
	automationCenterRuleName: "Название правила",
	automationCenterRuleNamePlaceholder: "напр., Сотрудник в отпуске",
	automationCenterRuleSavedSuccess: "Правило успешно сохранено!",
	automationCenterSearchSelectUsers: "Найти и выбрать пользователей",
	automationCenterSelectAction: "Выберите действие",
	automationCenterSelectActionToExecute: "Выберите действие для выполнения",
	automationCenterSelectDomain: "Выберите домен",
	automationCenterSelectEvent: "Выберите событие",
	automationCenterSelectTriggerEvent: "Выберите событие, которое запускает это правило",
	automationCenterStatus: "Статус",
	automationCenterStatusFailed: "Ошибка",
	automationCenterStatusPartial: "Частично",
	automationCenterStatusSuccess: "Успешно",
	automationCenterSuccess: "Успешно",
	automationCenterThen: "Тогда...",
	automationCenterTitle: "Центр автоматизации",
	automationCenterTotalExecutions: "Всего выполнений",
	automationCenterTriggerEvent: "Событие триггера",
	automationCenterTriggerPayload: "Данные триггера",
	automationCenterUpdateRule: "Обновить правило",
	automationCenterValue: "Значение",
	automationCenterView: "Просмотр",
	automationCenterWhen: "Когда...",
	attendance: "Посещаемость",
	attendanceFlag: "Статус посещаемости",
	attendanceRequiringAttention: "Сотрудники, требующие внимания",
	attendanceNoAttentionItems: "Нет сотрудников, требующих внимания",
	attendanceMissingCheckIn: "Нет отметки прихода",
	attendanceMissingCheckOut: "Нет отметки ухода",
	attendanceEarlyLeave: "Ранний уход",
	attendanceEarlyMissings: "Ранние уходы",
	attendanceEarlyMissingHours: "Часы раннего ухода",
	attendanceLateHours: "Часы опоздания",
	attendanceShowWorkedHours: "Показывать отработанные часы",
	attendanceUnapprovedAbsence: "Неподтверждённое отсутствие",
	attendanceDeptAttendance: "Посещаемость по отделам",
	attendanceDeviceHealth: "Состояние устройств и синхронизация",
	attendanceLastSync: "Последняя синхронизация",
	attendanceLiveFeed: "Живая лента посещаемости",
	attendanceLiveUsers: "Активные пользователи",
	attendanceLiveTab: "Онлайн",
	attendanceInOffice: "В офисе",
	attendanceLiveInApit: "Онлайн в APIT",
	attendanceUsersInOfficeNow: "сотрудников сейчас в офисе",
	attendanceLiveInApitNow: "пользователей сейчас онлайн в APIT",
	attendanceNoOneInOffice: "Сейчас никого нет в офисе",
	attendanceNoLiveInApit: "Сейчас никто не онлайн в APIT",
	attendanceNoRecentPunches: "Нет недавних отметок",
	attendanceManualEntryTag: "Вручную",
	attendanceUnmappedPunch: "Не сопоставлено",
	attendancePendingItems: "в очереди",
	flexCardTotal: "Flex-карты",
	attendanceCards: "Карты посещаемости",
	flexCardTotalSubtitle: "Назначенные или игнорируемые Flex ID",
	flexCardsAttached: "Привязано",
	flexCardsAttachedSubtitle: "Уникальные ID, привязанные к пользователям",
	flexCardsIgnored: "Игнорируется",
	flexCardsIgnoredSubtitle: "Игнорируется в настройках HR",
	flexCardsDuplicateAttached: "Повторно привязано",
	flexCardIds: "ID карт",
	noDuplicateFlexCards: "Нет дубликатов",
	attendanceTrendPctOfEmployeesPresent: "% присутствующих сотрудников",
	yesterday: "Вчера",
	attendanceFilterThisWeek: "Эта неделя",
	attendanceFilterThisMonth: "Этот месяц",
	attendanceFilterCustom: "Произвольный период",
	attendanceSelectRange: "Выберите период",
	attendanceCustomRangeCapped: "Произвольный период ограничен 90 днями",
	attendanceLiveBadge: "LIVE",
	attendanceTitleToday: "Посещаемость за сегодня",
	attendanceTitleYesterday: "Посещаемость за вчера",
	attendanceTitleThisWeek: "Посещаемость за эту неделю",
	attendanceTitleThisMonth: "Посещаемость за этот месяц",
	attendanceTitleCustom: "Посещаемость за выбранный период",
	attendanceTitleTodayKpis: "Показатели посещаемости за сегодня",
	attendanceTitleYesterdayKpis: "Показатели посещаемости за вчера",
	attendanceTitleThisWeekKpis: "Показатели посещаемости за эту неделю",
	attendanceTitleThisMonthKpis: "Показатели посещаемости за этот месяц",
	attendanceTitleCustomKpis: "Показатели посещаемости за выбранный период",
	attendanceTrendDays: "Тренд посещаемости — последние {n} дней",
	attendanceNotAttendedYet: "Ещё не пришли",
	attendanceUpcomingAbsences: "Предстоящие отсутствия",
	attendanceUpcomingAbsencesEmpty: "Нет предстоящих отсутствий",
	attendanceUpcomingAbsencesTomorrow: "Завтра",
	attendanceUpcomingAbsencesInDays: "Через {days} дн.",
	attendanceExceptions: "Исключения посещаемости",
	attendanceExceptionsMissingCheckIn: "Пропущенные приходы",
	attendanceExceptionsMissingCheckOut: "Пропущенные уходы",
	attendanceExceptionsEarlyLeaves: "Ранние уходы",
	attendanceExceptionsUnapprovedAbsences: "Неподтверждённые отсутствия",
	attendanceExceptionsDuplicatePunches: "Повторные отметки",
	attendanceMonthlyKpis: "Ежемесячные показатели посещаемости",
	attendanceKpiRate: "Посещаемость",
	attendanceKpiAvgArrival: "Среднее время прихода",
	attendanceKpiLateArrivals: "Опоздания",
	attendanceKpiAbsentDays: "Дни отсутствия",
	attendanceKpiOvertimeHours: "Часы переработки",
	attendanceLeaveBalanceOverview: "Обзор баланса отпусков",
	attendanceLeaveBalanceVacationRemaining: "Остаток отпуска",
	attendanceLeaveBalanceSickUsed: "Использовано больничных",
	attendanceLeaveBalanceBusinessTrips: "Командировки",
	attendanceLeaveBalancePendingRequests: "Ожидающие заявки",
	attendanceLeaveBalanceCoverage: "{covered} из {total} сотрудников",
	attendanceTopInsights: "Ключевые показатели посещаемости",
	attendanceInsightNoData: "Пока нет данных для анализа",
	attendanceInsightHighestLateness: "У {dept} самый высокий уровень опозданий на этой неделе ({delta})",
	attendanceInsightFullAttendanceToday: "В {dept} 100% посещаемость",
	attendanceInsightTrendImproved: "Посещаемость улучшилась на {pct}% по сравнению с предыдущим периодом",
	attendanceInsightTrendDeclined: "Посещаемость снизилась на {pct}% по сравнению с предыдущим периодом",
	attendanceInsightApproachingOvertime: "{count} сотрудников приближаются к лимиту переработки",
	attendancePreviousWeek: "Прошлая неделя",
	attendanceCurrentWeek: "Эта неделя",
	attendanceAddInterval: "Добавить интервал",
	attendanceBreakLabel: "Перерыв",
	attendanceCorrectionMode: "Режим исправления",
	attendanceCustomIntervals: "Пользовательские интервалы",
	attendanceDashboard: "Панель посещаемости",
	attendanceReports: "Отчёты",
	attendanceCalendarTab: "Календарь",
	reports: "Отчёты",
	shiftCoverage: "Покрытие смен",
	previousPeriod: "Предыдущий период",
	nextPeriod: "Следующий период",
	failedToSave: "Не удалось сохранить комментарий к сверхурочным",
	expandForDailyDetail: "Развернуть строку для деталей по дням",
	noDataForPeriod: "Нет данных за этот период",
	attendanceHistory: "История посещаемости",
	attendanceDayOffTab: "Выходной",
	attendanceDayType: "Тип дня",
	attendanceDetectedIntervals: "Обнаруженные интервалы",
	attendanceEditDay: "Редактировать день",
	attendanceHrsTotal: "ч всего",
	attendanceViewWeek: "Неделя",
	attendanceViewMonth: "Месяц",
	attendanceViewDay: "День",
	day: "День",
	attendanceOpenFrom: "Открыто с {time}",
	attendanceFromStillActive: "С {time} → всё ещё активно",
	attendanceTotalWorked: "Всего отработано",
	attendanceMissingUncovered: "Пропуск / не покрыто",
	attendanceNoData: "Нет данных",
	attendanceNoDataForDay: "Нет данных посещаемости за этот день.",
	attendanceIntervalApprovedOk: "Утверждено / ОК",
	attendanceIntervalEachRowInvalid:
		"Укажите корректное время начала и окончания для каждого интервала",
	attendanceIntervalTimesInvalid: "Укажите корректное время начала и окончания",
	attendanceIntervalsMode: "Интервалы",
	attendanceIntervalsReviewHint:
		"Проверьте фактически отработанное, отпуска и пропуски. Добавьте ниже интервалы ручной корректировки: одобрено, работа, удалёнка, больничный, отпуск, без оплаты или другое.",
	attendanceLogSubtitle: "Ручной ввод посещаемости — работа, больничные, отпуск",
	attendanceLogTitle: "Журнал посещаемости",
	attendanceManualResolutionIntervals: "Интервалы ручной корректировки",
	attendanceMissingLabel: "Пропуск",
	attendanceNoManualIntervalsYet: "Ручные интервалы ещё не добавлены",
	attendanceNoUncovered: "Непокрытых интервалов не обнаружено",
	attendanceOptionalNotePlaceholder: "Необязательная заметка…",
	attendancePtoLeaveSection: "Отпуск / отсутствие",
	attendanceReport: "Отчёт посещаемости",
	attendanceResolveInterval: "Исправить этот интервал",
	attendanceResyncTooltip: "Пересинхронизировать посещаемость этого сотрудника",
	attendanceResyncSuccess: "Пересинхронизация посещаемости запущена",
	attendanceResyncFailed: "Не удалось пересинхронизировать посещаемость",
	attendanceSavedSuccess: "Посещаемость успешно сохранена",
	attendanceStatusOnTime: "Вовремя",
	attendanceStatusLate: "Опоздание",
	attendanceStatusAbsent: "Отсутствует",
	attendanceStatusUpcoming: "Предстоящий",
	attendanceStatusPto: "Отпуск / ОТ",
	attendanceStatusPartial: "Частично",
	attendanceStatusOpen: "Открыто",
	attendanceStatusWeekend: "Выходной",
	attendanceStatusHoliday: "Праздник",
	attendanceStatusNonWorking: "Нерабочий",
	attendanceSelectEmployeePrompt: "Выберите сотрудника для просмотра посещаемости",
	attendanceTrend: "Тренд посещаемости",
	attendanceTrendPctPresent: "% присутствует",
	attendanceUncoveredMissing: "Не покрыто / пропуск",
	attendanceUnsavedChanges: "Несохранённые изменения",
	attendanceWholeDayStatus: "Статус на весь день",
	shiftWorker: "Сменный работник",
	attendanceStatusShift: "Смена",
	attendanceIgnoreMode: "Игнорировать",
	attendanceIgnoreScopeWeekdays: "Дни недели",
	attendanceIgnoreScopeDateRange: "Диапазон дат",
	attendanceIgnoreScopeWeekdaysHint: "Применяется только к выбранным дням недели в этом периоде.",
	attendanceIgnoreScopeDateRangeHint: "Применяется ко всем дням в этом периоде.",
	attendanceIgnoreAppliesTo: "Применяется к",
	attendanceIgnoreLateArrival: "Опоздание",
	attendanceIgnoreEarlyLeave: "Ранний уход",
	attendanceIgnoreWindowStart: "Начало окна игнорирования",
	attendanceIgnoreWindowEnd: "Конец окна игнорирования",
	attendanceIgnoreRulesList: "Правила игнорирования",
	attendanceIgnoreRulesEmpty: "Правил игнорирования пока нет",
	attendanceIgnoreDaysOfWeekRequired: "Выберите хотя бы один день недели",
	attendanceIgnoredLabel: "Игнорируется",
	attendanceNoCardLabel: "Нет карты",
	attendanceWork: "Работа",
	attendanceWorked: "Отработано",
	attendanceWorkedIntervals: "Отработанные интервалы",
	attendanceMissingIntervals: "Пропущенные интервалы",
	attendanceStillInOffice: "Всё ещё в офисе",
	attendanceAddEvent: "Добавить событие",
	attendanceAutoClosed: "Автоматически закрыто",
	attendanceAutoClosedAt: "Автоматически закрыто в {time}",
	automaticEvent: "Автоматическое событие",
	attendanceAddAttendanceEvent: "Добавить событие посещаемости",
	attendanceDeleteEventTitle: "Удалить событие посещаемости?",
	attendanceDeleteEventText: "Будет удалено только это вручную добавленное событие входа/выхода.",
	attendanceNoMissingIntervals: "Нет пропущенных интервалов за этот день",
	attendanceOfficeSince: "С {time}",
	attendanceLastOutAt: "Последний выход {time}",
	attendanceEventSingular: "событие",
	attendanceEventPlural: "события",
	attendancePunchIn: "Вход",
	attendancePunchOut: "Выход",
	solveThis: "Исправить",
	editSolvedStatus: "Изменить статус решения",
	officeStatus: "Статус офиса",
	outOfOffice: "Вне офиса",
	noPunches: "Нет отметок",
	lastActionWasCheckIn: "Последнее действие — вход",
	lastActionWasCheckOut: "Последнее действие — выход",
	noCheckInYet: "Вход ещё не зафиксирован",
	manual: "Вручную",
	resolved: "Решено",
	attendanceManualStatusApplyTicketTimeTo: "Применить время тикета к",
	attendanceManualStatusColumnAttendanceType: "Тип посещаемости",
	attendanceManualStatusColumnTimeAction: "Действие со временем",
	attendanceManualStatusMapsToType: "Соответствует типу посещаемости",
	attendanceManualStatusTicketTimeAction: "Действие со временем в автоматизации тикета",
	attendanceTicketTimePhraseAdd: "Добавить время: {type}",
	attendanceTicketTimePhraseSubtract: "Вычесть время: {type}",
	attendanceTimeOpAdd: "Добавить время тикета",
	attendanceTimeOpNone: "Без изменения учёта времени",
	attendanceTimeOpSubtract: "Вычесть время тикета",
	attendanceTypeOptionAbsent: "Отсутствует",
	attendanceTypeOptionBusinessTrip: "Командировка",
	attendanceTypeOptionHolidayNonWorking: "Праздник / нерабочий",
	attendanceTypeOptionJustifiedAbsence: "Уважительное отсутствие (по уважительной причине)",
	attendanceTypeOptionMaternity: "Декретный отпуск",
	attendanceTypeOptionPaidVacation: "Оплачиваемый отпуск",
	attendanceTypeOptionRemote: "Удалённая работа",
	attendanceTypeOptionSickLeave: "Больничный",
	attendanceTypeOptionUnjustifiedAbsence: "Неуважительное отсутствие (без уважительной причины)",
	attendanceTypeOptionUnpaidLeave: "Отпуск без сохранения оплаты",
	attendanceTypeOptionWork: "Работа",
	audio: "Аудио",
	autoDeletion: "Автоудаление",
	averageDailyHours: "Среднесуточные часы",
	avgDaily: "Среднее за день",
	avgDailyHours: "Средние часы в день",
	avgHoursPerWorkingDay: "Средние часы за рабочий день",
	avgOrderValue: "Средний чек",
	avgResolutionTime: "Среднее время решения",
	avgResponseTime: "Среднее время ответа",
	avgTracksPerPlaylist: "Среднее треков/плейлист",
	back: "Назад",
	bank: "Банк",
	bankAccount: "Банковский счёт",
	bankCart: "Банковская карта",
	bankEmitet: "Банк",
	banner: "Баннер",
	baseSalary: "Оклад",
	baseSalaryHourlyLinked: "Обновляет почасовую ставку из оклада ÷ обычные часы (если часы > 0).",
	basicInformation: "Основная информация",
	beginningOfAcquaintance: "Начало знакомства",
	beginningOfContract: "Начало контракта",
	beginningOfTraining: "Начало обучения",
	benefits: "Льготы",
	bestSeller: "Бестселлер",
	bestSellers: "Бестселлеры",
	bestSellingItemsByRevenue: "Лучшие товары по доходу",
	bitrate: "Битрейт",
	biweekly: "Раз в две недели",
	blogItems: "Элементы блога",
	blogs: "Блоги",
	bonuses: "Премии",
	bpm: "BPM",
	branch: "Филиал электронной сети",
	storeBranches: "Филиалы",
	storeBranchName: "Название филиала",
	storeBranchLatitude: "Широта",
	storeBranchLongitude: "Долгота",
	storeBranchLoadError: "Не удалось загрузить филиал.",
	branches: "Список филиалов",
	branchesCitiesVillages: "Филиалы, Города, Деревни",
	brand: "Бренд",
	brands: "Бренды",
	building: "Здание",
	businessTrip: "Командировка",
	buttonText: "Текст кнопки",
	bypassSteps: "Обход шагов",
	calAddCalendarTooltip: "Создать календарь и поделиться с коллегами",
	calAddEvent: "Добавить событие",
	calAddReminder: "Добавить напоминание",
	calAlarm15m: "За 15 минут",
	calAlarm1d: "За 1 день",
	calAlarm1h: "За 1 час",
	calAlarm1w: "За 1 неделю",
	calAlarm2d: "За 2 дня",
	calAlarm2h: "За 2 часа",
	calAlarm30m: "За 30 минут",
	calAlarm5m: "За 5 минут",
	calAlarmAtEvent: "Во время события",
	calAllDay: "Весь день",
	calApiNotConfigured: "API календаря не настроен.",
	calCalendarColorLabel: "Цвет календаря",
	calCalendarCreateFailed: "Не удалось создать календарь",
	calCalendarCreated: "Календарь создан",
	calCalendarDeleted: "Календарь удалён",
	calCalendarNameLabel: "Название календаря",
	calCalendarNamePh: "напр. Планирование команды",
	calCalendarNameRequired: "Введите название календаря",
	calCalendarSelect: "Календарь",
	calCalendarUpdateFailed: "Не удалось обновить календарь",
	calCalendarUpdated: "Календарь обновлён",
	calCalendarsLabel: "Календари:",
	calGoogleCalendarLabel: "Google Календарь:",
	calGoogleCalendarPrefix: "Google",
	calMeetingsLabel: "Встречи:",
	calCancel: "Отмена",
	calCheckAll: "Выбрать все",
	calColor: "Цвет",
	calCreateCalendar: "Создать календарь",
	calDay: "День",
	calDayOverviewTitle: "День",
	calDefaultCalendarName: "Календарь",
	calDelete: "Удалить",
	calDeleteCalendarHasEvents: "В этом календаре {count} событий. Что с ними сделать?",
	calDeleteCalendarNoEvents: "Это действие нельзя отменить.",
	calDeleteCalendarOnly: "Удалить только календарь",
	calDeleteCalendarTitle: "Удалить календарь?",
	calDeleteCalendarWithEvents: "Удалить с событиями",
	calDeleteEventText: "Действие нельзя отменить.",
	calDeleteEventTitle: "Удалить событие?",
	calDeleteFailed: "Ошибка удаления",
	calDescription: "Описание",
	calDescriptionPh: "Описание (необязательно)",
	calEditCalendarTitle: "Изменить календарь",
	calEditCalendarTooltip: "Изменить календарь",
	calEditEvent: "Изменить событие",
	calEditTooltip: "Изменить",
	calEnd: "Конец",
	calEndBeforeStart: "Конец не может быть раньше начала",
	calEndTime: "Время окончания",
	calEvent: "Событие",
	calEventCreated: "Событие создано",
	calEventDeleted: "Событие удалено",
	calEventTitle: "Название",
	calEventTitlePh: "Название события",
	calEventUpdated: "Событие обновлено",
	calEventsPlural: "событий",
	calExportIcs: "Экспорт .ics",
	calFailedLoadEvents: "Не удалось загрузить события",
	calHrBirthdayEvent: "День рождения",
	calHrBirthdays: "Дни рождения",
	calHrContractEnd: "Конец контракта",
	calHrContractEndEvent: "Окончание контракта",
	calHrContractStart: "Начало контракта",
	calHrContractStartEvent: "Старт контракта",
	calHrIdEvent: "Окончание удостоверения",
	calHrIdExpiry: "Срок удостоверения",
	calHrPassportEvent: "Окончание паспорта",
	calHrPassportExpiry: "Срок паспорта",
	calHrPositionReview: "Пересмотр должности",
	calHrPositionReviewEvent: "Обзор должности",
	calHrSalaryReview: "Пересмотр зарплаты",
	calHrSalaryReviewEvent: "Обзор зарплаты",
	calImportButton: "Импорт",
	calImportEventsTitle: "Импорт событий",
	calImportFoundInFile: "найдено в файле. Выберите календарь для импорта:",
	calImportIcs: "Импорт .ics",
	calImportedEventTitle: "Импортированное событие",
	calItLabel: "ИТ:",
	calItWarrantyEnd: "Окончание гарантии",
	calItWarrantyEndEvent: "Окончание гарантии",
	calMonth: "Месяц",
	calNewCalendarTitle: "Новый календарь",
	calNewEvent: "Новое событие",
	calNoCalendar: "Без календаря",
	calNoCalendarUncategorised: "Без календаря (без категории)",
	calNoEventsInIcs: "В файле .ics нет событий",
	calNoEventsThisDay: "Нет событий в этот день.",
	calNoRemindersThisDay: "Нет напоминаний в этот день.",
	calDayWeatherMap: "Карта погоды",
	calDayHourlyForecast: "Почасовой прогноз",
	calDayWeatherUnavailable: "Прогноз недоступен для этой даты",
	calDayEventsSection: "События",
	calDayRemindersSection: "Напоминания",
	calOpenProfile: "Открыть профиль",
	calPeopleLabel: "Люди:",
	calReminders: "Напоминания",
	calRemindersLabel: "Напоминания:",
	calAttendanceLabel: "Посещаемость:",
	calSecurityLabel: "Безопасность:",
	calSecurityAlerts: "Тревоги",
	calSecuritySessions: "Сессии",
	calSecurityTokenExpiry: "Истечение токена",
	calRemindersToggle: "Активные напоминания",
	calSave: "Сохранить",
	calSaveFailed: "Ошибка сохранения",
	calShareWithUsers: "Поделиться с пользователями",
	calShareWithUsersPh: "Найдите и выберите людей",
	calStart: "Начало",
	calStartEndRequired: "Нужны время начала и конца",
	calStartTime: "Время начала",
	calSwalDelete: "Удалить",
	calTaskHigh: "Высокий",
	calTaskLow: "Низкий",
	calTaskMedium: "Средний",
	calTaskUrgent: "Срочный",
	calTasksLabel: "Задачи:",
	calTicketsLabel: "Тикеты:",
	calToday: "Сегодня",
	calUserFallback: "Пользователь",
	calWeek: "Неделя",
	calculatePayroll: "Рассчитать зарплату",
	calculated: "Рассчитано",
	calculations: "Расчёты",
	calendarEventType: "Событие календаря",
	calling: "Вызов",
	cancel: "Отменить",
	clearText: "Очистить текст",
	cancelAction: "Отменить действие",
	cancelBack: "Отменить обратно",
	cancelled: "Отменено",
	cannotBeUndone: "Это действие нельзя отменить.",
	cannotPayOnline: "Невозможно оплатить онлайн",
	cart: "Сотрудники",
	categories: "Категории",
	category: "Категория",
	categoryPerformance: "Производительность категорий",
	certificate: "Сертификат",
	certificateImages: "Изображения сертификатов",
	certificates: "Сертификаты",
	changedDate: "Дата изменения",
	channel: "Канал",
	channelWritePermissionDescription: "Только администраторы чата могут писать сообщения",
	channels: "Каналы",
	charts: "Графики",
	chat: "Чат",
	chatActions: "действия чата",
	chatActiveLabel: "активны...",
	chatAddOption: "Добавить вариант",
	chatAddUsers: "Добавить пользователей",
	chatAddedToGroupNotification: "Добавлены в групповой чат",
	chatAddedYouToGroup: "добавил вас в",
	chatAudioCall: "аудиозвонок",
	chatBulkDeleteFailed: "Массовое удаление не удалось.",
	chatBulkForwardFailed: "Массовая пересылка не удалась.",
	chatCallMessage: "Сообщение о звонке",
	chatChoosingEmoji: "выбирают эмодзи...",
	chatClickMapToChoosePoint: "Нажмите на карту, чтобы выбрать точку.",
	chatCoordinatesUnavailable: "Координаты недоступны",
	chatCopyCoordinates: "Копировать координаты",
	chatCopyCoordinatesFailed: "Не удалось скопировать координаты.",
	chatCreatePoll: "Создать опрос",
	chatCurrent: "Текущая",
	chatCurrentLocation: "Текущая локация",
	chatDashboard: "Панель управления чатом",
	chatDeleteFailed: "Удаление не удалось",
	chatDeleteForMe: "Удалить чат",
	chatDeleteForMeConfirm:
		"Удалить этот чат только у вас? Видимая история будет очищена, и чат исчезнет из боковой панели.",
	chatDeleteForMeOnly: "Удалить только у меня",
	chatDeleteForParticipants: "Удалить и у участников",
	chatDeleteLocation: "Удалить локацию",
	chatDeleteSelectedMessagesDescription:
		"Это действие удаляет выбранные сообщения из вашего чата. Сообщения, которые нельзя удалить с текущими правами, будут отмечены как неудачные.",
	chatDeleteSelectedMessagesTitle: "Удалить выбранные сообщения",
	chatDeletionPartialWarning:
		"Результаты удаления могут быть частичными, если некоторые сообщения уже удалены или проверка прав не прошла.",
	chatDepartmentSaveFailed: "Не удалось обновить отдел",
	chatDepartmentSaveFailedTryAgain: "Попробуйте снова обновить отдел.",
	chatDeselectAllMessages: "Снять выделение",
	chatDestinationChatsLabel: "Чаты назначения",
	chatDestinationChatsPlaceholder: "Выберите один или несколько чатов",
	chatDirect: "Прямой чат",
	chatDirectChat: "Личный чат",
	chatBlockUser: "Заблокировать пользователя",
	chatBlockedContacts: "Заблокированные контакты",
	chatClearHistory: "Очистить историю",
	chatClearHistoryConfirm: "Очистить историю этого чата только у вас?",
	chatEditFailed: "Не удалось отредактировать сообщение",
	chatEditFailedTryAgain: "Пожалуйста, попробуйте отредактировать еще раз.",
	chatEditMessagePlaceholder: "Редактировать сообщение...",
	writeMessage: "Введите сообщение...",
	chatEditingMessage: "Редактирование сообщения",
	chatMuteNotifications: "Отключить уведомления",
	chatMuteFor8Hours: "На 8 часов",
	chatMuteFor1Day: "На 1 день",
	chatMuteFor1Week: "На 1 неделю",
	chatMuteForever: "Навсегда",
	chatPinChat: "Закрепить чат",
	chatArchiveChat: "Архивировать чат",
	chatUnarchiveChat: "Вернуть из архива",
	chatArchivedSection: "Архив",
	chatPinnedSection: "Закреплённые",
	chatAllSection: "Все",
	chatMarkUnread: "Отметить как непрочитанное",
	chatMarkRead: "Отметить как прочитанное",
	chatBadgeDirect: "Личный",
	chatBadgeGroup: "Группа",
	chatBadgeChannel: "Канал",
	chatUnblockUser: "Разблокировать пользователя",
	chatUnmuteNotifications: "Включить уведомления",
	chatUnpinChat: "Открепить чат",
	chatUsers: "Пользователи",
	chatExitSelectionMode: "Выйти из режима выбора",
	chatExpired: "Истекло",
	chatForwardFailed: "Пересылка не удалась",
	chatForwardSelectedMessagesTitle: "Переслать выбранные сообщения",
	chatForwardableLabel: "пересылаемых",
	chatGeolocationUnavailable: "Геолокация недоступна в этом браузере.",
	chatGroupChat: "групповой чат",
	chatGroupInfo: "Информация о группе",
	chatGroupMembers: "Участники группы",
	chatGroupSettings: "Настройки группы",
	chatGroupSettingsDescription: "Установите изображение группы и связанный HR отдел",
	chatID: "ID чата",
	chatImageUploadFailed: "Не удалось загрузить изображение",
	chatImageUploadFailedTryAgain: "Попробуйте загрузить другое изображение.",
	chatIncludeLabel: "Включить",
	chatIsChoosingEmoji: "выбирает эмодзи...",
	chatIsTyping: "печатает...",
	chatLastUpdated: "Последнее обновление",
	chatLatitude: "Широта",
	chatLive: "В эфире",
	chatLiveFor: "Активно еще",
	chatLiveLocation: "Живая геолокация",
	chatLiveLocationOptInWarning:
		"Живая геолокация включается только вручную и может быть остановлена в любой момент.",
	chatLiveLocationSharingActive: "Трансляция геолокации активна",
	chatLoadingLocation: "Загрузка локации...",
	chatLoadingPoll: "Загрузка опроса...",
	chatLongitude: "Долгота",
	chatMessagesCannotBeForwarded: "сообщение(я) нельзя переслать, они будут пропущены.",
	chatMessagesDeleted: "Сообщения удалены",
	chatMessagesForwarded: "Сообщения пересланы",
	chatMoreActions: "Другие действия",
	chatNoAvailableUsersToAdd: "Все доступные пользователи уже состоят в этой группе.",
	chatNoBackground: "Без обоев",
	chatNoChatsFound: "Чаты не найдены",
	chatNoMessagesForwarded: "Ни одно сообщение не удалось переслать.",
	chatNoSelectedMessagesDeleted: "Не удалось удалить ни одно выбранное сообщение.",
	chatOpenDepartmentPage: "Открыть страницу отдела",
	chatOpenMap: "Открыть карту",
	chatOptionalAddressLabel: "Необязательная метка адреса",
	chatOwnMessagesLabel: "свои",
	chatPartialDelete: "Частичное удаление",
	chatPartialForward: "Частичная пересылка",
	chatPattern: "Узор",
	chatPickOnMap: "Выбрать на карте",
	chatPickPointOnMap: "Выберите точку на карте.",
	chatPinnedLocation: "Закрепленная локация",
	chatPollAddAnotherOption: "Добавить еще вариант",
	chatPollAddOptionFailed: "Не удалось добавить вариант.",
	chatPollAllowAddingOptions: "Разрешить добавление вариантов",
	chatPollAllowMultipleAnswers: "Разрешить несколько ответов",
	chatPollAllowRevote: "Разрешить переголосование",
	chatPollAnonymous: "Анонимный опрос",
	chatPollAnonymousCannotAddOptions: "Анонимный тест не может разрешать добавление вариантов.",
	chatPollAtLeastOptions: "Минимум вариантов:",
	chatPollAutoClose: "Автозакрытие",
	chatPollChangeVote: "Изменить голос",
	chatPollChooseCorrectAnswer: "Выберите хотя бы один правильный ответ.",
	chatPollCloseDate: "Дата закрытия",
	chatPollCloseDateOrOpenPeriod: "Используйте либо дату закрытия, либо период, но не оба.",
	chatPollCloseFailed: "Не удалось закрыть опрос.",
	chatPollClosePoll: "Закрыть опрос",
	chatPollCorrectAnswer: "Правильный ответ",
	chatPollCorrectAnswers: "Правильные ответы",
	chatPollCreateFailed: "Не удалось создать опрос.",
	chatPollDeletePoll: "Удалить опрос",
	chatPollDescriptionMax: "Описание не более",
	chatPollExplanationMax: "Объяснение не более",
	chatPollHideResultsUntilClosed: "Скрыть результаты до закрытия",
	chatPollIncorrectAnswer: "Неправильный ответ",
	chatPollLeaveEmptyKeepOpen: "Оставьте пустым, чтобы не закрывать",
	chatPollLeaveEmptyNoTimer: "Оставьте пустым, чтобы без таймера",
	chatPollLoadVotersFailed: "Не удалось загрузить проголосовавших.",
	chatPollMultipleChoice: "Несколько вариантов",
	chatPollNewOption: "Новый вариант",
	chatPollNoVoteYet: "Пока нет голоса",
	chatPollNoVotersForOption: "Для этого варианта голосов нет.",
	chatPollOpenPeriod: "Период открытости",
	chatPollOptionMax: "Вариант не более",
	chatPollOptionRequired: "Вариант обязателен.",
	chatPollOptionsUnique: "Варианты должны быть уникальными.",
	chatPollPublic: "Публичный",
	chatPollQuestionMax: "Длина вопроса не более",
	chatPollQuestionRequired: "Вопрос обязателен.",
	chatPollQuiz: "Тест",
	chatPollQuizExplanation: "Объяснение теста",
	chatPollRegular: "Обычный",
	chatPollResultsHiddenUntilClosed: "Результаты скрыты до закрытия опроса.",
	chatPollSearchVoters: "Поиск голосовавших",
	chatPollShuffleOptions: "Перемешать варианты",
	chatPollSingleChoice: "Один вариант",
	chatPollSingleChoiceOneCorrect: "В тесте с одним выбором только один правильный ответ.",
	chatPollSubmitVoteFailed: "Не удалось отправить голос.",
	chatPollViewVoters: "Посмотреть голосовавших",
	chatPollVoteRecorded: "Голос учтен",
	chatPollVotersLabel: "голосов",
	chatPollVotersTitle: "Кто голосовал",
	chatPollYouVoted: "Вы проголосовали.",
	chatPollYouVotedCanChange: "Вы проголосовали и можете изменить ответ.",
	chatPreviewChronological: "Предпросмотр (по времени)",
	chatProvider: "Провайдер",
	chatReadCurrentLocationFailed: "Не удалось определить ваше текущее местоположение.",
	chatRefreshCurrentLocation: "Обновить текущую локацию",
	chatRuleAllow: "Да",
	chatRuleDeny: "Нет",
	chatRuleTimed: "Да, но только ограниченное время",
	chatRuleTimerDescription:
		"Например, укажите 1, чтобы разрешить действие только в течение первой минуты после отправки.",
	chatRuleTimerMinutes: "Таймер в минутах",
	chatSearchMessage: "Поиск сообщения",
	chatSelectAllMessages: "Выбрать все",
	chatSelectDepartment: "Выберите HR отдел",
	chatSelectOrLoadLocationFirst: "Сначала выберите или загрузите локацию.",
	chatSelectRepeatingBackground: "Выберите повторяющиеся обои",
	chatSelectUsersToAdd: "Выберите пользователей для добавления",
	chatSelectedLabel: "выбрано",
	chatSelectionMode: "Режим выбора",
	chatSendCurrentLocation: "Отправить текущую локацию",
	chatSendLocationFailed: "Не удалось отправить локацию.",
	chatSendPinnedLocation: "Отправить закрепленную локацию",
	chatSendVenue: "Отправить место",
	chatSentAt: "Отправлено",
	chatSettings: "Настройки чата",
	chatSettingsEditRule: "Редактирование сообщений",
	chatSettingsEditRuleDescription:
		"Выберите, можно ли редактировать отправленные сообщения всегда, никогда или только ограниченное время.",
	chatSettingsForwardRule: "Пересылка сообщений",
	chatSettingsForwardRuleDescription:
		"Разрешить пересылку всегда, никогда или только в течение ограниченного времени после отправки сообщения.",
	chatSettingsGlobalPageSubtitle:
		"Настройте правила личных чатов здесь один раз. Правила общих групп могут менять только их администраторы.",
	chatSettingsGlobalPageTitle: "Глобальные настройки чата",
	chatSettingsGlobalRulesDescription:
		"Эти правила действуют во всех личных чатах.",
	chatSettingsGlobalSavedSuccess: "Глобальные настройки чата успешно обновлены",
	chatSettingsCompactMode: "Компактный режим",
	chatSettingsCompactModeDescription:
		"Уменьшить отступы и размер аватаров, чтобы на боковой панели помещалось больше чатов.",
	chatSettingsSidebarDescription: "Настройте отображение чатов на левой боковой панели.",
	chatSettingsSidebarTitle: "Боковая панель чата",
	chatSettingsShowLastMessage: "Показывать последнее сообщение",
	chatSettingsShowLastMessageDescription:
		"Показывать предпросмотр последнего сообщения и его дату или время на боковой панели чата.",
	chatSettingsReplyRule: "Ответы на сообщения",
	chatSettingsReplyRuleDescription:
		"Управляйте ответами: всегда, никогда или только в течение ограниченного времени после отправки сообщения.",
	chatSettingsResetToGlobal: "Восстановить правила группы по умолчанию",
	chatSettingsRulesAdminOnly: "Только администраторы чата могут менять эти правила.",
	chatSettingsRulesDescription:
		"Настройте пересылку, ответы и редактирование сообщений, при необходимости с ограничением по времени.",
	chatSettingsRulesTitle: "Правила чата",
	chatSettingsSaveFailed: "Не удалось сохранить настройки чата",
	chatSettingsSaveFailedTryAgain: "Пожалуйста, попробуйте еще раз.",
	chatSettingsUsingCustomRules:
		"В этой группе действуют правила, заданные администраторами.",
	chatSettingsUsingGlobalRules: "В этой группе действуют правила по умолчанию.",
	chatShareLocation: "Поделиться локацией",
	chatSkipLabel: "Пропустить",
	chatSkippedLabel: "пропущено",
	chatStartCall: "Начать звонок",
	chatStartLiveSharing: "Начать живую передачу",
	chatStopLiveSharing: "Остановить живую трансляцию",
	chatType: "Тип чата",
	chatTypeToSearch: "Введите для поиска",
	chatTyping: "печатают...",
	chatUnnamedChat: "Чат без названия",
	chatUpdatingSharedLocationFor: "Обновляем эту геолокацию еще",
	chatUploadGroupImage: "Загрузить изображение группы",
	chatUserInfo: "Информация о пользователе",
	chatUsersSaveFailed: "Не удалось добавить пользователей",
	chatUsersSaveFailedTryAgain: "Попробуйте снова добавить выбранных пользователей.",
	chatVenue: "Место",
	chatVenueTitle: "Название места",
	chatVideoCall: "видеозвонок",
	chatViewReportedMessages: "Посмотреть жалобы",
	chatWaitingDeviceCoordinates: "Ожидание координат устройства...",
	childcarePayment: "Оплата присмотра за детьми",
	chooseBoard: "Выберите доску для просмотра ее категорий и задач",
	cities: "Города",
	city: "Город",
	clear: "Очистить",
	clearFilters: "Очистить фильтры",
	clickTheButtonBelowToTakeTheNextStepOnYourJourney:
		"Нажмите кнопку ниже, чтобы сделать следующий шаг в вашем путешествии",
	client: "Клиент",
	contactEngagement: "Вовлеченность клиентов",
	contactGroup: "Группа клиентов",
	contactGroups: "Группы клиентов",
	contactPlaylist: "Плейлист клиента",
	contactProfile: "Профиль клиента",
	clients: "клиентов",
	contactsByGender: "Клиенты по полу",
	contactsByGroup: "Клиенты по группам",
	contactsUsing: "клиентов используют",
	contactsWithCarts: "Клиенты с корзинами",
	contactsWithFavorites: "Клиенты с избранным",
	clockInOut: "Приход / Уход",
	close: "Закрыть",
	closeNavigation: "Закрыть навигацию",
	closeTicket: "Закрыть билет",
	closed: "Закрыто",
	closed_late: "Закрыто после срока",
	closedDate: "Дата закрытия",
	closedTickets: "Закрытые билеты",
	cmDashboard: "Панель управления контентом",
	code: "Код",
	coin: "Монета",
	coinBurnTime: "Время сжигания монет",
	coinCount: "Количество монет",
	color: "Цвет",
	comment: "Комментарий",
	commentTicket: "Комментарий к билету",
	commissions: "Комиссионные",
	communicationPreferences: "Предпочтения связи",
	community: "Сообщество",
	company: "Компания",
	completed: "Завершено",
	completedDate: "Дата выполнения",
	completedTasks: "Завершенные задачи",
	completionRate: "процент завершения",
	confirm: "Подтвердить",
	confirmAction: "Подтвердить действие",
	contactForm: "Форма обратной связи",
	contactForms: "Формы обратной связи",
	contactType: "Тип контакта",
	contacts: "Контакты",
	contentByType: "Контент по типам",
	contentItems: "Элементы контента",
	contentManagementOverview: "Обзор системы управления контентом",
	contentOverTime: "Контент, созданный со временем (последние 30 дней)",
	continue: "Продолжить",
	contract: "Контракт",
	contractEndDate: "Дата окончания договора",
	contractStartDate: "Дата начала договора",
	contractor: "Подрядчик",
	copy: "Копировать",
	costOfBuildingPart: "Стоимость строительной части",
	costOfBuildingPermit: "Стоимость разрешения на строительство",
	country: "Страна",
	cpu: "Процессор",
	create: "Заказ",
	createBoard: "Создать новую доску",
	createChat: "Создать чат",
	createGroupChat: "Создать групповой чат",
	createGroupSubmit: "Создать",
	addNewCategory: "Добавить новую категорию",
	createNewCategory: "Создать новую категорию",
	created: "Создано",
	createdAt: "Создано в",
	createdBy: "Создано",
	createdByUser: "Создано пользователем",
	critical: "Критический",
	crmDashboard: "Панель управления CRM",
	cta1: "Вызов к действию секция 1",
	cta2: "Вызов к действию секция 2",
	cta3: "Вызов к действию секция 3",
	currency: "Валюта",
	currentMonth: "Текущий месяц",
	currentWeek: "Текущая неделя",
	currentlyStreaming: "в настоящее время транслируется",
	currentlyWorking: "Сейчас на работе",
	custom: "Другое",
	customerAcquisition: "Привлечение клиентов",
	customerBaseOverview: "Обзор клиентской базы",
	customerInsights: "Аналитика клиентов",
	customerRelationshipOverview: "Обзор управления взаимоотношениями с клиентами",
	dashboard: "Доска",
	dashboardSubtitle: "Подзаголовок панели управления",
	database: "База данных",
	date: "Дата",
	dateOfBirth: "Дата рождения",
	dates: "даты",
	datingAttendance: "Посещаемость свиданий",
	dayOff: "Выходной",
	meeting: "Встреча",
	dayOffForAllEmployees: "Выходной для всех сотрудников",
	dayOffRemoved: "Выходной удален",
	dayOffSavedForAllEmployees: "Выходной сохранен для всех сотрудников",
	days: "дни",
	daysLeft: "дней осталось",
	daysOfWeek: "Дни недели",
	daysWorked: "Отработанные дни",
	deadLine: "Срок",
	deadline: "Крайний срок",
	debt: "Долг",
	decline: "Отклонить",
	deductions: "Удержания",
	defaultEnergyMax: "Максимальная энергия по умолчанию",
	defaultEnergyMin: "Минимальная энергия по умолчанию",
	defaultStream: "Стандартный поток",
	defaultStreams: "Потоки по умолчанию",
	defaultStreamsDesc: "потоки по умолчанию",
	delays: "Задержки",
	delete: "Удалить",
	deleteForEveryone: "Удалить для всех",
	deletePermanently: "Удалить навсегда",
	deleteRule: "Удалить правило",
	deleteSelected: "Удалить выбранные",
	deleted: "Удален",
	delivery: "Доставка",
	deliveryAddress: "Адресс доставки",
	deliveryMethod: "Способ доставки",
	density: "плотность",
	department: "Отделение",
	departmentChatsHelp:
		"Привяжите групповые чаты и каналы к отделу. Список синхронизируется с полем «отдел» в каждом чате.",
	departmentLinkedChats: "Чаты отдела",
	departments: "Отделения",
	desc: "Оисание",
	description: "Описание",
	designer: "Дизайнер",
	detailedFilters: "Подробные фильтры",
	detailedSteps: "Детальные шаги",
	details: "Детали",
	developed: "Разработанно",
	developedBy: "Разработано",
	difference: "Разница",
	diplomaImages: "Изображения диплома",
	directMessages: "Прямые сообщения",
	disableSteps: "Отключить шаги",
	disabledSteps: "Отключенные шаги",
	disk: "Диск",
	distributionByPaymentType: "Распределение по типам оплаты",
	domainFacility: "Объект",
	domainFinance: "Финансы",
	domainHR: "HR",
	domainIT: "ИТ",
	domainKey: "Ключ домена",
	domainOther: "Другое",
	domainSecurity: "Безопасность",
	done: "Готово",
	download: "Скачать",
	downloadAsContact: "Скачать как контакт",
	draft: "Черновик",
	dragToReorder: "Перетащите для переупорядочения",
	dropFilesHere: "Перетащите файлы сюда",
	dropFilesHereOrClick: "Перетащите файлы сюда или нажмите, чтобы добавить больше",
	dropzoneText: "Перетащите изображения сюда или нажмите, чтобы выбрать файлы",
	dueDate: "Срок выполнения",
	duration: "Продолжительность",
	ecommerceDashboard: "Панель управления электронной коммерцией",
	edit: "Редактировать",
	editComment: "Редактировать комментарий",
	editItem: "Редактировать элемент",
	editProject: "Редактировать проект",
	editRule: "Редактировать правило",
	edited: "Редактировано",
	editingRule: "Редактирование правила",
	email: "Эл. адрес",
	sendEmail: "Отправить письмо",
	employee: "Сотрудник",
	employees: "сотрудников",
	employeesPerDepartment: "Сотрудники по отделам",
	employeesWithOT: "Сотрудники со сверхурочными",
	employerExpenses: "Расходы работодателя",
	employmentStatus: "Статус занятости",
	emptyTrash: "Очистить корзину",
	end: "Конец",
	endDate: "Дата окончания",
	endDateMustBeLaterThanStartDate: "Дата окончания должна быть позже даты начала",
	endDateShort: "Дата окончания",
	endOfTraining: "Окончание обучения",
	endTime: "Время окончания",
	ends: "Заканчивается",
	energyLevel: "Уровень энергии",
	energyScheduling: "Энергетическое планирование",
	enterAmount: "Введите сумму",
	enterFeatureSuffix: "Введите суффикс функции",
	enterFeatureText: "Введите текст функции",
	enterGroupName: "Введите название группы...",
	enterLabel: "Введите название",
	enterPersons: "Введите количество людей",
	enterRuleName: "Введите название правила",
	entityTypeLabel: "Тип сущности",
	entry: "Вход",
	error: "Ошибка",
	errorMessage: "Произошла ошибка, пожалуйста, попробуйте снова.",
	errorOccurred: "Произошла ошибка",
	errorPageButton: "Вернуть меня домой",
	errorPageHelpText: "Нужна помощь? Свяжитесь с нашей службой поддержки",
	errorPageSecondaryButton: "Сообщить об этой проблеме",
	errorPageSubtitle: "Страница, которую вы ищете, не существует",
	errorPageText:
		"Не волнуйтесь, это случается с лучшими из нас! Страница могла быть перемещена, удалена, или вы могли ввести неправильный URL. Давайте вернем вас на правильный путь.",
	errorPageTitle: "Упс! Что-то пошло не так",
	errorUserNotFound: "Пользователь не найден",
	estOTPay: "Примерная оплата OT",
	estimatedHours: "Оценка времени",
	eventType: "Тип события",
	exit: "Выход",
	expectedSalary: "Ожидаемая зарплата",
	expireDate: "Дата истечения",
	expired: "Истекло",
	expiresOn: "Истекает",
	expiringIdCards: "Истекающие удостоверения личности",
	expiringPassports: "Истекающие паспорта",
	export: "Экспорт",
	exportData: "Экспорт данных",
	exportToExcel: "Экспорт в Excel",
	extraLarge: "очень большой",
	extraSmall: "очень маленький",
	faqQuestions: "Вопросы FAQ",
	favorites: "Избранное",
	features: "Функции",
	female: "Женский",
	fields: "Поля",
	file: "Файл",
	fileHasBeenRemoved: "Файл был удален",
	fileMovedToTrash: "Файл перемещен в корзину",
	fileRestored: "Файл восстановлен",
	fileWillBeMovedToTrash: "Файл будет перемещен в корзину",
	files: "Файлы",
	filesRestored: "Файлы восстановлены",
	filesWillBePermanentlyDeleted: "файлов будут удалены безвозвратно.",
	filter: "Фильтр",
	filterBy: "Фильтр по",
	filters: "Фильтры",
	finish: "Закончить",
	fired: "Уволен",
	firstIn: "Первый вход",
	firstName: "Имя",
	forgotPassword: "Забыли пароль?",
	forward: "Переслать",
	forwardMessage: "Переслать сообщение",
	forwarded: "Переслано",
	forwardedFrom: "Переслано от",
	fri: "Пятница",
	from: "От",
	fromAttendanceLogs:
		"Заполняется из журналов посещаемости для этого сотрудника и периода; можно изменить.",
	fromDb: "Из базы данных",
	fromHrSettings: "Настройки HR",
	gallery: "Галерея",
	gender: "Пол",
	genderDistribution: "Распределение по полу",
	globalFilter: "Глобальный фильтр",
	globalSearchClose: "Закрыть",
	globalSearchCmd_goCalendar_desc: "События календаря",
	globalSearchCmd_goCalendar_label: "Перейти в календарь",
	globalSearchCmd_goChat_desc: "Открыть сообщения",
	globalSearchCmd_goChat_label: "Перейти в чат",
	globalSearchCmd_goCrm_desc: "Управление клиентами",
	globalSearchCmd_goCrm_label: "Перейти в CRM",
	globalSearchCmd_goFinance_desc: "Финансовый модуль",
	globalSearchCmd_goFinance_label: "Перейти в финансы",
	globalSearchCmd_goHr_desc: "Модуль кадров",
	globalSearchCmd_goHr_label: "Перейти в HR",
	globalSearchCmd_goIt_desc: "IT-оборудование",
	globalSearchCmd_goIt_label: "Перейти в IT",
	globalSearchCmd_goProjects_desc: "База проектов",
	globalSearchCmd_goProjects_label: "Перейти к проектам",
	globalSearchCmd_goRadio_desc: "Музыка и плейлисты",
	globalSearchCmd_goRadio_label: "Перейти к радио",
	globalSearchCmd_goTickets_desc: "Система поддержки",
	globalSearchCmd_goTickets_label: "Перейти к заявкам",
	globalSearchCmd_goTodo_desc: "Доски и задачи",
	globalSearchCmd_goTodo_label: "Перейти к задачам",
	globalSearchCmd_messageUser_desc: "Открыть чат для сообщения",
	globalSearchCmd_messageUser_label: "Написать пользователю",
	globalSearchCmd_newContact_desc: "Добавить клиента CRM",
	globalSearchCmd_newClient_label: "Новый клиент",
	globalSearchCmd_newOrder_desc: "Создать заказ",
	globalSearchCmd_newOrder_label: "Новый заказ",
	globalSearchCmd_newProject_desc: "Создать проект",
	globalSearchCmd_newProject_label: "Новый проект",
	globalSearchCmd_newTask_desc: "Создать задачу",
	globalSearchCmd_newTask_label: "Новая задача",
	globalSearchCmd_newTicket_desc: "Создать заявку",
	globalSearchCmd_newTicket_label: "Новая заявка",
	globalSearchCommandBadge: "Команда",
	globalSearchCommands: "Команды",
	globalSearchCopied: "Скопировано!",
	globalSearchCopyLink: "Копировать ссылку",
	globalSearchDirectMessage: "Личное сообщение",
	globalSearchFilterAll: "Все",
	globalSearchFilterCalendar: "Календарь",
	globalSearchFilterChats: "Чаты",
	globalSearchFilterDevices: "Устройства",
	globalSearchFilterEcom: "Электронная коммерция",
	globalSearchFilterFinance: "Финансы",
	globalSearchFilterPeople: "Люди",
	globalSearchFilterProjects: "Проекты",
	globalSearchFilterRadio: "Радио",
	globalSearchFilterTickets: "Заявки",
	globalSearchFilterTodo: "Задачи",
	globalSearchHidePreview: "Скрыть предпросмотр",
	globalSearchNavigate: "Навигация",
	globalSearchOpen: "Открыть",
	globalSearchOpenInNewTab: "Открыть в новой вкладке",
	globalSearchPageBadge: "Страница",
	globalSearchPlaceholder: "Искать в APIT: пользователи, заявки, чаты, устройства…",
	globalSearchPreviewAddress: "Адрес",
	globalSearchPreviewArtist: "Исполнитель",
	globalSearchPreviewChat: "Чат",
	globalSearchPreviewCompany: "Компания",
	globalSearchPreviewCreated: "Создано",
	globalSearchPreviewDeviceId: "ID устройства",
	globalSearchPreviewEmail: "Email",
	globalSearchPreviewEmployeeNumber: "Таб. №",
	globalSearchPreviewEnd: "Конец",
	globalSearchPreviewInfo: "Инфо",
	globalSearchPreviewIp: "IP",
	globalSearchPreviewLocation: "Место",
	globalSearchPreviewMac: "MAC",
	globalSearchPreviewNumber: "Номер",
	globalSearchPreviewOrderNumber: "Заказ №",
	globalSearchPreviewPhone: "Телефон",
	globalSearchPreviewSent: "Отправлено",
	globalSearchPreviewStart: "Начало",
	globalSearchPreviewUsername: "Имя пользователя",
	globalSearchPreviewVendor: "Поставщик",
	globalSearchPreviewVersion: "Версия",
	globalSearchRecentSearches: "Недавние запросы",
	globalSearchRecentlyOpened: "Недавно открытые",
	globalSearchSectionArtists: "Исполнители",
	globalSearchSectionAttendanceDevices: "Устройства учёта",
	globalSearchSectionBrands: "Бренды",
	globalSearchSectionCalendarEvents: "События календаря",
	globalSearchSectionCameras: "Камеры",
	globalSearchSectionChats: "Чаты",
	globalSearchSectionClientGroups: "Группы клиентов",
	globalSearchSectionClients: "Клиенты",
	globalSearchSectionCpus: "Процессоры",
	globalSearchSectionDepartments: "Отделы",
	globalSearchSectionEcomCategories: "Категории",
	globalSearchSectionFinanceCardIssuers: "Эмитенты карт",
	globalSearchSectionFinanceCards: "Карты",
	globalSearchSectionFinanceCategories: "Финансовые категории",
	globalSearchSectionFinanceTransactions: "Транзакции",
	globalSearchSectionGpus: "Видеокарты",
	globalSearchSectionKeyboards: "Клавиатуры",
	globalSearchSectionLaptops: "Ноутбуки",
	globalSearchSectionMessages: "Сообщения",
	globalSearchSectionMice: "Мыши",
	globalSearchSectionMonitors: "Мониторы",
	globalSearchSectionOrders: "Заказы",
	globalSearchSectionPcs: "ПК",
	globalSearchSectionPlaylists: "Плейлисты",
	globalSearchSectionPositions: "Должности",
	globalSearchSectionPrinters: "Принтеры",
	globalSearchSectionProblems: "Проблемы",
	globalSearchSectionProducts: "Товары",
	globalSearchSectionProjects: "Проекты",
	globalSearchSectionRams: "ОЗУ",
	globalSearchSectionRoms: "Накопители",
	globalSearchSectionRooms: "Помещения",
	globalSearchSectionRouters: "Маршрутизаторы",
	globalSearchSectionSmbs: "SMB",
	globalSearchSectionSoftware: "ПО",
	globalSearchSectionSwitches: "Коммутаторы",
	globalSearchSectionTelephones: "Телефоны",
	globalSearchSectionTickets: "Заявки",
	globalSearchSectionTodoBoards: "Доски",
	globalSearchSectionTodoCategories: "Категории",
	globalSearchSectionTodoTasks: "Задачи",
	globalSearchSectionTracks: "Треки",
	globalSearchSectionUsers: "Люди",
	globalSearchSectionWarrantyProviders: "Гарантийные партнёры",
	globalSearchSelectPreview: "Выберите элемент для предпросмотра",
	globalSearchShortcutHint: "Ctrl + K",
	globalSearchShowPreview: "Показать предпросмотр",
	globalSearchSubtitle: "Поиск по всем модулям",
	globalSearchSuggest1: "Искать заявки, назначенные на меня",
	globalSearchSuggest2: "Найти сотрудника по email",
	globalSearchSuggest3: "Искать в сообщениях чата",
	globalSearchSuggest4: "Найти устройство по IP",
	globalSearchSuggest5: "Искать клиента по телефону",
	globalSearchSuggest6: "Перейти к проектам",
	globalSearchTrySearchingFor: "Попробуйте искать",
	goBack: "Назад",
	goToMessage: "Перейти к сообщению",
	goToUserAttendanceTab: "Пользователи → посещаемость",
	goToUserAttendanceTabTooltip:
		"Открыть этого сотрудника в HR «Пользователи» на вкладке «Посещаемость»",
	gpu: "Видеокарта",
	grossSalary: "Валовая зарплата",
	group: "Группа",
	groupChat: "Групповой чат",
	groupChatWritePermissionDescription: "Все участники чата могут писать сообщения",
	groupChats: "Групповые чаты",
	groupName: "Название группы (необязательно)",
	healthInsurance: "Медицинская страховка",
	healthInsuranceBenefit: "Медстрахование (льгота)",
	help: "Помощь",
	hideAllSteps: "Скрыть все шаги",
	hideHistory: "Скрыть историю",
	hideProjectDetails: "Скрыть детали проекта",
	hideTableColumnFilters: "Скрыть фильтры столбцов",
	hideTimeline: "Скрыть временную шкалу",
	high: "Высокий",
	highestSpendingCustomers: "Клиенты с наибольшими расходами",
	highlight: "Выделить",
	highlightFeature: "Выделить функцию",
	history: "История",
	historyTable: "Таблица истории",
	holiday: "Праздник",
	holidayNonWorking: "Праздник / нерабочий день",
	hourlyRate: "Почасовая ставка",
	hourlyRateBaseLinked: "Обновляет оклад из почасовой ставки × обычные часы (если часы > 0).",
	hr2025RateReferenceTables: "Справочные таблицы ставок 2025",
	hrAccrualAnnualTotal: "Итого за год: {amount} дн.",
	hrAccrualDaily: "Ежедневно (÷ 365)",
	hrAccrualEachDay: "Каждый день: +{amount} дн. отпуска",
	hrAccrualEachMonthFirst: "Каждое 1-е число: +{amount} дн. отпуска",
	hrAccrualMethod: "Метод начисления",
	hrAccrualMethodDesc: "Как накапливается отпуск",
	hrAccrualMonthly: "Ежемесячно (÷ 12, 1-го числа)",
	hrAccrualMonthlyEquivalent: "Месячный эквивалент: ~{amount} дн.",
	hrAccrualPreview: "Предпросмотр начисления",
	hrArmeniaIncomeTaxCalculator: "Калькулятор подоходного налога (Армения)",
	hrArmeniaTaxRates: "Налоговые ставки Армении",
	hrCalcSummaryGrossToNet:
		"При зарегистрированной зарплате {gross} AMD вы получите {net} AMD «на руки» после удержания {deductions} AMD налогов и взносов.",
	hrCalcSummaryNetToGross:
		"Чтобы получать {net} AMD «на руки», в договоре должна быть указана валовая зарплата {gross} AMD.",
	hrCalculationBreakdown: "Детализация расчёта",
	hrCalculationDirection: "Направление расчёта",
	hrDefaultBenefitsDescription:
		"Эти значения по умолчанию применяются ко всем расчётам зарплаты, если не задано иначе для сотрудника.",
	hrDefaultMonthlyBenefits: "Льготы по умолчанию в месяц (AMD)",
	hrDesiredNetSalaryLabel: "Желаемая чистая зарплата (на руки)",
	hrEmployeePensionLabel: "Пенсионные отчисления сотрудника:",
	hrEmployeePensionRate: "Ставка пенсионных отчислений сотрудника",
	hrEmployeePensionRateDesc: "Обязательно для родившихся после 1973 (2,5%)",
	hrEmployerPensionRate: "Ставка пенсионных отчислений работодателя",
	hrEmployerPensionRateDesc: "Пенсионные отчисления работодателя (2,5%)",
	hrFailedToSaveSettings: "Не удалось сохранить настройки",
	hrGrossSalaryAMD: "Валовая зарплата (AMD)",
	hrGrossSalaryDescription: "Введите сумму, указанную в трудовом договоре",
	hrGrossSalaryLabel: "Валовая зарплата (зарегистрированная / по договору)",
	hrGrossSalaryRegistered: "Валовая зарплата (зарегистрированная)",
	hrGrossToNet: "Брутто → Нетто",
	hrHealthInsuranceAges: "Медстрахование (возраст 18–65)",
	hrHealthInsuranceBenefit: "Медицинская страховка",
	hrHealthInsuranceBenefitDesc: "Ежемесячные отчисления работодателя на медстрахование (AMD)",
	hrHealthInsuranceEmployeeColumn: "Сотрудник",
	hrHealthInsuranceEmployeeShare: "Медстрахование (доля сотрудника)",
	hrHealthInsuranceStateColumn: "Государство",
	hrITSector: "IT-сектор (10% подоходного налога)",
	hrITSectorDesc: "Сотрудник лицензированной IT-компании",
	hrIncomeTax: "Подоходный налог",
	hrIncomeTaxLabel: "Подоходный налог:",
	hrIncomeTaxRate: "Ставка подоходного налога",
	hrIncomeTaxRateDesc: "Фиксированные 20% в Армении с 2020 года",
	hrLeaveAccrualConfiguration: "Настройка накопления отпуска",
	hrLiveRates: "Актуальные ставки",
	hrLunchCoverage: "Питание",
	hrLunchCoverageDesc: "Ежемесячная компенсация питания (AMD)",
	hrMandatoryHealthInsurance: "Обязательное медстрахование (18–65)",
	hrMandatoryHealthInsuranceDesc: "Включить ступени медстрахования 2025",
	hrMilitaryStampRate: "Ставка военного сбора",
	hrMilitaryStampRateDesc: "Укажите 0, если не применяется",
	hrMonthlyFee: "Ежемесячная плата",
	hrNetSalaryDescription: "Введите, сколько вы хотите получать «на руки»",
	hrNetSalaryLabel: "Чистая зарплата:",
	hrNetSalaryTakeHome: "Чистая зарплата (на руки)",
	hrNetToGross: "Нетто → Брутто",
	hrOvertimeRateMultiplier: "Множитель ставки переработки",
	hrOvertimeRateMultiplierDesc: "напр. 1,5× означает надбавку 50% за переработку",
	hrOvertimeRules: "Правила переработки",
	hrBreakIntervals: "Перерывы",
	hrBreakIntervalsDesc:
		"Фиксированные ежедневные интервалы (например, обед), исключаемые из рабочего времени для всех. Можно добавить несколько.",
	hrBreakIntervalsEmpty: "Перерывы не настроены",
	hrBreakIntervalStart: "Начало перерыва",
	hrBreakIntervalEnd: "Конец перерыва",
	hrAddBreakInterval: "Добавить перерыв",
	hrOvertimeThreshold: "Порог переработки (часов/день)",
	hrOvertimeThresholdDesc: "Часы сверх этого порога оплачиваются по ставке переработки",
	hrPensionMandatory: "Обязательная / добровольная до 07/2018 (5%)",
	hrPensionNone: "Не участник (0%)",
	hrPensionPost2018: "Добровольная после 07/2018 (5%)",
	hrPensionSystem: "Пенсионная система",
	hrPensionSystemDesc: "Ваш статус участия в накопительной пенсии",
	hrSettingsPageSubtitle: "Настройте расчёт зарплаты, отпуска и правила посещаемости",
	hrSettingsPageTitle: "Настройки HR",
	hrSettingsUpdatedSuccessfully: "Настройки HR успешно обновлены",
	hrSickDaysPerYear: "Дней больничного в год",
	hrSickDaysPerYearDesc: "Оплачиваемые дни больничного за календарный год",
	hrSocialPaymentPension: "Социальный платёж (пенсия)",
	hrSocialTaxRate: "Ставка социального налога",
	hrSocialTaxRateDesc: "Сейчас 0% в Армении (заменён пенсионными взносами)",
	hrStampFee: "Сбор (военный страховой фонд)",
	hrStampFeeTooltip: "Военный страховой фонд — ступенчатая фиксированная плата по валовой зарплате",
	hrStandardWorkSchedule: "Стандартный график работы",
	hrStateHealthContribution: "Государственный взнос на медстрахование",
	hrStateHealthContributionNote:
		"добавляется государством к пакету медстрахования (не удерживается из зарплаты).",
	hrSuffixDays: "дн.",
	hrSuffixHours: "ч",
	hrSuffixTimes: "×",
	hrSummary: "Итог",
	hrTabDefaultBenefits: "Льготы по умолчанию",
	hrTabLeaveAccrual: "Накопление отпуска",
	hrTabTaxCalculator: "Налоговый калькулятор",
	hrTabTaxesArmenia: "Налоги (Армения)",
	hrTabWorkSchedule: "График работы",
	hrTaxPreviewTitle: "Предпросмотр налога (на 500 000 AMD брутто)",
	hrTaxRatesDescription:
		"Ставки применяются к валовой зарплате. Вводите в процентах (напр. 20 = 20%).",
	hrTaxRatesDisclaimer:
		"Ставки по законодательству Армении 2025–2026. Подоходный налог: 20% стандарт, 10% для лицензированных IT-компаний. Пенсия: 5% (обязательная/добровольная до 2018) или ровно 5% (добровольная после 2018). Повышенная ставка 10% на пенсию — для обязательных/до-2018 при доходе свыше 500 000 AMD. Для расчёта зарплаты консультируйтесь с бухгалтером.",
	hrThresholdWarning: "Предупреждение о пороге",
	hrThresholdWarningText:
		"Ваша зарплата близка к границе ступени (100k / 200k / 500k / 1M AMD). В этих точках сбор и медстрахование переходят на более высокую ступень, поэтому небольшое увеличение брутто может снизить нетто. Калькулятор всегда показывает минимальный брутто для запрошенного нетто.",
	hrTickets: "HR билеты",
	hrTotalDeductions: "Всего удержаний",
	hrTotalEmployeeDeductionsLabel: "Всего удержаний с сотрудника:",
	hrTransportAllowance: "Транспортная компенсация",
	hrTransportAllowanceDesc: "Ежемесячная транспортная компенсация (AMD)",
	hrVacationDaysPerYear: "Дней отпуска в год",
	hrVacationDaysPerYearDesc: "Полная годовая норма (минимум в Армении: 20)",
	hrWorkingDayEnd: "Окончание рабочего дня",
	hrWorkingDayEndDesc:
		"Ожидаемое окончание смены. Дневные часы рассчитываются по времени начала и конца",
	hrWorkingDayStart: "Начало рабочего дня",
	hrWorkingDayStartDesc: "Ожидаемое время прихода для учета посещаемости и опозданий",
	hrAttendanceAutoCloseTime: "Время автоматического выхода",
	hrAttendanceAutoCloseTimeDesc: "В это время незакрытые входы за предыдущий день автоматически закрываются",
	hrWeekendDays: "Выходные дни",
	hrAttendanceDeviceSync: "Синхронизация устройств учёта",
	hrIgnoredAttendanceDevicePins: "Игнорируемые PIN устройства",
	hrIgnoredAttendanceDevicePinsDesc:
		"Отметки с этих PIN ZKTeco пропускаются при синхронизации: не сохраняются и не вызывают предупреждений о несопоставленных PIN. Для уволенных карт, тестовых или сотрудников вне системы.",
	hrIgnoredAttendanceDevicePinsInputDesc:
		"Введите PIN устройства и нажмите Enter. Сохраняется как 5-значный код (напр. 1104 → 01104). Удаление — по × на бейдже.",
	hrIgnoredAttendanceDevicePinsPlaceholder: "Введите PIN и нажмите Enter",
	hrIgnoredAttendanceUsers: "Игнорируемые пользователи",
	hrIgnoredAttendanceUsersDesc: "Эти пользователи остаются в списках пользователей, но скрываются на экранах посещаемости.",
	hrIgnoredAttendanceUsersPlaceholder: "Выберите пользователя и нажмите Enter",
	hrWeekendDaysDesc: "Выберите дни недели, которые являются нерабочими выходными",
	hrWorkingDaysPerWeek: "Рабочие дни в неделю",
	hrWorkingDaysPerWeekDesc: "Пн–Пт = 5, Пн–Сб = 6",
	hrWorkingHoursPerDay: "Рабочие часы в день",
	hrWorkingHoursPerDayDesc: "Норма часов до начала переработки",
	href: "Ссылка",
	humanResources: "Кадры",
	id: "ID",
	idCard: "Удостоверение личности",
	idCardEndDate: "Дата окончания ID карты",
	idCardNo: "ID Карта №",
	idCardStartDate: "Дата начала ID карты",
	idCart: "ID Карта",
	image: "Изображение",
	immediateSupervisor: "Непосредственный руководитель",
	importance: "Важность",
	important: "Важно",
	inProgress: "В процессе",
	inSelectedPeriod: "в выбранный период",
	inStock: "В наличии",
	in_progress: "В процессе",
	inactive: "Неактивный",
	inactiveTime: "Неактивное время",
	incident: "Инцидент",
	incomeTaxAmount: "Сумма подоходного налога",
	incomeTaxRate: "Ставка подоходного налога (%)",
	incomingCall: "Входящий звонок",
	incomingVideoCall: "Входящий видеозвонок",
	incorrectLogin: "Вы ввели неверный логин или пароль",
	index: "#",
	inputInArmenian: "Ввод на армянском",
	inputInLatin: "Ввод на латинице",
	inputInNumbers: "Введите числа",
	inputInRussian: "Ввод на русском",
	inputNumber: "Ввод номера",
	inputNumbers: "Введите числа",
	instagramPosts: "Посты Instagram",
	insufficientVacationBalance: "Недостаточный остаток отпуска",
	interview1: "Собеседование",
	interview2: "Знакомство",
	interview3: "Обучение",
	interview4: "Стажирование",
	interviewDate: "Дата собеседования",
	interviewTime: "Время собеседования",
	introSection: "Вводная секция",
	invalidDate: "Неверная дата доставки",
	inventorySummary: "Сводка по складу",
	ip: "IP",
	ipAddress: "IP-адрес",
	isActive: "Активный",
	isColor: "Цвет",
	isPrivateOffice: "Является ли частным офисом",
	isPublic: "Публичный",
	isSystem: "Системный",
	itHierarchyAddCatalogCpu: "Добавить процессор (справочник)",
	itHierarchyAddCatalogGpu: "Добавить видеокарту (справочник)",
	itHierarchyAddCatalogRam: "Добавить ОЗУ (справочник)",
	itHierarchyAddCatalogRom: "Добавить накопитель (справочник)",
	itHierarchyAddMonitor: "Добавить монитор",
	itHierarchyAddLaptop: "Добавить ноутбук",
	itHierarchyAttachedPc: "Подключённый ПК",
	itHierarchyAddPc: "Добавить ПК",
	itHierarchyAddPrinter: "Добавить принтер",
	itHierarchyAddRoom: "Добавить комнату",
	itHierarchyAddRouter: "Добавить маршрутизатор",
	itHierarchyAddSwitch: "Добавить коммутатор",
	itHierarchyAddWarrantyProvider: "Добавить поставщика гарантии",
	itHierarchyMonitorsOnPc: "Мониторы у этого ПК",
	itHierarchyPcsInRoom: "ПК в этой комнате",
	itHierarchyPcsUsingPart: "ПК с этой комплектующей",
	itHierarchyLaptopsUsingPart: "Ноутбуки с этой комплектующей",
	itHierarchyPcsWithWarranty: "ПК с этим поставщиком гарантии",
	itHierarchyPrintersOnPc: "Принтеры у этого ПК",
	itHierarchyRoutersInRoom: "Маршрутизаторы в этой комнате",
	itHierarchySwitchesInRoom: "Коммутаторы в этой комнате",
	itUsedInOtherPlaces: "Используется в других местах",
	itTickets: "IT билеты",
	items: "элементы",
	justifiedAbsence: "Уважительное отсутствие",
	keyText: "Ключевой текст",
	keyboards: "Клавиатуры",
	label: "Название",
	language: "Язык",
	languagePickerLabel: "Язык",
	large: "большой",
	last7Days: "входили последние 7 дней",
	lastAction: "Последнее действие",
	lastLogin: "Последний вход",
	lastName: "Фамилия",
	lastOut: "Последний выход",
	lastPunch: "Последняя отметка",
	lasts: "Продолжительность",
	late: "Опоздал",
	lateDeparture: "Поздний уход",
	latestCustomerOrders: "Последние заказы клиентов",
	leader: "Руководитель",
	attendanceManagersFilter: "Руководители",
	attendanceLeadersFilter: "Руководители",
	leaveBalance: "Баланс отпуска",
	legacyRelatedList: "Устаревшее поле",
	list: "Список",
	linkCopied: "Ссылка скопирована",
	listeners: "Слушателей",
	livingAddress: "Адрес проживания",
	loading: "Загрузка",
	loanDeductions: "Удержания по кредиту",
	localCode: "Локальный код",
	logOut: "Выйти",
	login: "Логин",
	loginButton: "Войти",
	loginFailed: "Ошибка входа",
	loginFailedMessage: "Пожалуйста, проверьте свои учетные данные",
	loginSuccess: "Успешный вход",
	loginSuccessMessage: "Вы успешно вошли в систему",
	loginToStartSession: "Войдите, чтобы начать сеанс",
	logout: "Выход",
	low: "Низкий",
	lunchCoverage: "Компенсация питания",
	mac: "MAC",
	macAddress: "MAC-адрес",
	main: "Главный",
	mainInformation: "Основная информация",
	mainInfo: "Основная информация",
	contactInfo: "Контактная информация",
	personalInfo: "Личная информация",
	workingInfo: "Рабочая информация",
	probation: "Испытательный срок",
	educationInfo: "Образование",
	male: "Мужской",
	manualAdjustments: "Ручные корректировки",
	manualAttendanceEntry: "Ручной ввод",
	manualOptions: "Варианты",
	maps: "Карты",
	maritalStatus: "Семейное положение",
	markAllAsRead: "Отметить все как прочитанные",
	markSelectedAsRead: "Отметить выбранные как прочитанные",
	maternityLeave: "Декрет",
	maxEnergy: "Максимальная энергия",
	maxFilesReached: "Максимальное количество файлов достигнуто",
	maxSize: "Максимальный размер",
	mediaGallery: "Галерея",
	mediaGalleryDescription: "Описание галереи медиа",
	mediator: "Посредник",
	medium: "Средний",
	members: "Участники",
	menu: "Меню",
	message: "Сообщение",
	messages: "Сообщения",
	messagesByType: "Сообщения по типу",
	messagesOverTime: "Сообщения за время (Последние 30 дней)",
	militaryStampAmount: "Сумма военного сбора",
	militaryStampRate: "Ставка военного сбора",
	minimap: "Миникарта",
	minEnergy: "Минимальная энергия",
	minute: "минута",
	minutes: "Минуты",
	missingInterval: "Непокрытый интервал",
	mon: "Понедельник",
	monitor: "Монитор",
	monitors: "Мониторы",
	month: "Месяц",
	monthly: "Ежемесячно",
	mood: "Настроение",
	more: "Дополнительный",
	moreDetailed: "Подробнее",
	moreThan: "Более чем",
	motherProject: "Материнский проект",
	mounted: "Установлено",
	mouses: "Мышки",
	moveToTrash: "Переместить в корзину",
	movedToTrash: "Перемещен в корзину",
	myActiveSteps: "Мои активные шаги",
	myInvolvement: "Мое участие",
	myProjects: "Мои проекты",
	myRole: "Моя роль",
	mySteps: "Мои шаги",
	myTickets: "Мои билеты",
	na: "Н/Д",
	name: "Имя",
	netCash: "Чистыми наличными",
	netOfficial: "Чистая официальная",
	netSalary: "Чистая зарплата",
	newClients: "Новые клиенты",
	newClientsOverTime: "Новые клиенты со временем (последние 30 дней)",
	newMessage: "Новое сообщение",
	newProducts: "Новые товары",
	newProject: "Новый проект",
	newProjects: "Новые проекты",
	newThisPeriod: "Новые за этот период",
	newTicket: "Новый билет",
	newTicketCreatedBy: "Новый билет создан",
	newTracks: "Новые треки",
	newTracksOverTime: "Новые треки со временем (последние 30 дней)",
	next: "Следующий",
	nextComposition: "Следующий состав",
	nextStep: "Следующий шаг",
	noAccess: "Нет доступа",
	noActiveSteps: "Нет активных шагов",
	noBoardsFound: "Нет досок",
	noCategoriesFound: "Нет категорий",
	noCategoryDataAvailable: "Нет данных по категориям",
	noContent: "Нет контента",
	noCustomerDataAvailable: "Нет данных о клиентах",
	noData: "Данные отсутствуют",
	noDataAvailable: "Нет доступных данных",
	noDataAvailableForSelectedPeriod: "Нет данных за выбранный период",
	noDepartment: "Нет отдела",
	noDepartments: "Нет отделов",
	noDescription: "Описание не найдено",
	noEmail: "Нет email",
	noExpiringIdCards: "Нет истекающих удостоверений личности",
	noExpiringPassports: "Нет истекающих паспортов",
	noGroup: "Без группы",
	noMediaDescription: "Описание медиа не найдено",
	noMediaFound: "Медиа не найдено",
	noMoreItems: "Нет больше элементов",
	noName: "Без имени",
	noNeedStep45: "Не нужно шаг 4-5",
	noNotifications: "Нет уведомлений",
	noOrdersInSelectedPeriod: "Нет заказов за выбранный период",
	noOvertimeRecords: "Записи о сверхурочных не найдены",
	noPaymentDataAvailable: "Нет данных об оплате",
	noProjectsAssigned: "Нет назначенных проектов",
	noProjectsAssignedOrInvolved: "Нет назначенных или вовлеченных проектов",
	noRecentContacts: "Нет недавних клиентов",
	noRecentContent: "Нет недавнего контента",
	noRecentTickets: "Нет недавних билетов",
	noRecentTracks: "Нет недавних треков",
	noRecipientInformation: "Нет информации о получателе",
	noResponsible: "Нет ответственного",
	noResult: "Ничего не найдено",
	noResults: "Ничего не найдено",
	noResultsFound: "Результатов не найдено",
	noRulesAdded: "Правила планирования не добавлены",
	noStatusData: "Нет данных о статусе",
	noSystemDaysOffThisMonth: "В этом месяце нет общих выходных",
	noTaskDataAvailable: "Нет доступных данных о задаче",
	noTasksYet: "Нет задач",
	noTasksYetDescription: "Нет задач",
	noUpcomingBirthdays: "Нет предстоящих дней рождения",
	noUsersFound: "Пользователи не найдены",
	noUsersInDepartment: "В этом отделе нет пользователей",
	noWorkHourData: "Нет данных рабочего времени",
	no_priority: "Без приоритета",
	nonWorking: "Нерабочий день",
	none: "Нет",
	notAvailable: "Продукт недоступен",
	notCorrectLoginCredentials: "Неправильные учетные данные для входа",
	notLoggedInToday: "Сегодня не входил",
	notPlaced: "Не размещено",
	notPresent: "Отсутствует",
	notResponded: "Не отвечено",
	notWorking: "Не работает",
	deviceProblems: "Проблемы устройств",
	openTickets: "Открытые заявки",
	note: "Примечание",
	nothingFound: "Ничего не найдено",
	notifications: "Уведомления",
	notificationsBellAria: "Открыть уведомления",
	similarTicketNotifications: "Уведомления по похожим тикетам",
	number: "Число",
	"office-map": "Карта офиса",
	officeMapActivatePlacement: "Включить размещение",
	officeMapAgent: "Агент",
	officeMapAll: "Все",
	officeMapAttendanceDevice: "Устройство посещаемости",
	officeMapAttendanceDevices: "Посещаемость",
	officeMapCable: "Кабель",
	officeMapCableLinePlaced: "Кабельная линия размещена",
	officeMapCableRemovedFromMap: "Кабель убран с карты",
	officeMapCables: "Кабели",
	officeMapCamera: "Камера",
	officeMapCameras: "Камеры",
	officeMapNvr: "NVR",
	officeMapChat: "Чат",
	officeMapChatWasNotCreated: "Чат не был создан",
	officeMapConnectToCamera: "Подключиться к камере",
	officeMapCpu: "CPU",
	officeMapDeactivate: "Отключить",
	officeMapDeviceDetails: "Детали устройства",
	officeMapDeviceId: "ID устройства",
	officeMapDisableDragging: "Отключить перетаскивание",
	officeMapEnableDragging: "Включить перетаскивание",
	officeMapEndDeviceOptional: "Конечное устройство (необязательно)",
	officeMapFailedToMoveCable: "Не удалось переместить кабель",
	officeMapFailedToMoveItem: "Не удалось переместить элемент",
	officeMapFailedToMoveRoomArea: "Не удалось переместить зону комнаты",
	officeMapFailedToOpenChat: "Не удалось открыть чат",
	officeMapFailedToPlaceItem: "Не удалось разместить элемент",
	officeMapFailedToPlaceUser: "Не удалось разместить пользователя",
	officeMapFailedToRemoveCable: "Не удалось убрать кабель",
	officeMapFailedToRemoveItem: "Не удалось убрать элемент",
	officeMapFailedToRemoveRoomArea: "Не удалось убрать зону комнаты",
	officeMapFailedToSaveCableLine: "Не удалось сохранить кабельную линию",
	officeMapFailedToSaveRoomArea: "Не удалось сохранить зону комнаты",
	officeMapFinishArea: "Завершить область",
	officeMapFinishCable: "Завершить кабель",
	officeMapForbidden: "Запрещено",
	officeMapIp: "IP",
	officeMapItem: "Элемент",
	officeMapItemPlaced: "Элемент размещён",
	officeMapItemRemovedFromMap: "Элемент убран с карты",
	officeMapLaptop: "Ноутбук",
	officeMapLaptops: "Ноутбуки",
	officeMapLayers: "Слои",
	officeMapLinkedItRoom: "Связанная IT-комната",
	officeMapLive: "Онлайн",
	officeMapMac: "MAC",
	officeMapMin: "мин.",
	officeMapMonitors: "Мониторы",
	officeMapNetworkCable: "Сетевой кабель",
	officeMapNoDevicesInArea: "В этой зоне нет размещённых устройств или пользователей.",
	officeMapNoPermissionToPlaceItem: "У вас нет прав размещать этот элемент.",
	officeMapNoPermissionToPlaceNetworkCable: "У вас нет прав размещать сетевой кабель.",
	officeMapNoPermissionToPlaceRoomArea: "У вас нет прав размещать зону комнаты.",
	officeMapNoPermissionToRemoveItem: "У вас нет прав убирать этот элемент с карты.",
	officeMapNoPermissionToRemoveNetworkCable: "У вас нет прав убирать сетевой кабель с карты.",
	officeMapNoPermissionToRemoveRoomArea: "У вас нет прав убирать зону комнаты с карты.",
	officeMapNotAvailable: "Н/Д",
	officeMapNotConnected: "Не подключено",
	officeMapPc: "ПК",
	officeMapPcs: "ПК",
	officeMapPlacement: "Размещение",
	officeMapPleaseSelectItemFirst: "Сначала выберите элемент",
	officeMapPleaseSelectRoomFirst: "Сначала выберите комнату",
	officeMapPoints: "Точки",
	officeMapPorts: "Порты",
	officeMapPrinted: "Напечатано",
	officeMapPrinters: "Принтеры",
	officeMapRam: "RAM",
	officeMapRemoveFromMap: "Убрать с карты",
	officeMapRom: "ROM",
	officeMapRoomArea: "Зона комнаты",
	officeMapRoomAreaPlaced: "Зона комнаты размещена",
	officeMapRoomAreaRemovedFromMap: "Зона комнаты убрана с карты",
	officeMapRoomAreas: "Комнаты",
	officeMapRoomContents: "Содержимое комнаты",
	officeMapRouter: "Маршрутизатор",
	officeMapRouters: "Маршрутизаторы",
	officeMapSelectItem: "Выберите элемент",
	officeMapSelectRoom: "Выберите комнату",
	officeMapSpeed: "Скорость",
	officeMapStartDeviceOptional: "Начальное устройство (необязательно)",
	officeMapSwitches: "Коммутаторы",
	officeMapTelephone: "Телефон",
	officeMapTelephones: "Телефоны",
	officeMapUnknown: "Неизвестно",
	officeMapUrl: "URL",
	officeMapUserPlacedOnMap: "Пользователь размещён на карте",
	officeMapUsers: "Пользователи",
	officeMapViewContents: "Открыть содержимое",
	officeMapViewFullDetails: "Открыть полные детали",
	offline: "Оффлайн",
	offlinePaymentOnly: "Только оффлайн оплата",
	oldProject: "Старый проект",
	onSale: "В продаже",
	onSecond: "На секунду",
	onTime: "Вовремя",
	onTimeRate: "Доля вовремя",
	oneOf: "Один из",
	open: "Открыть",
	openBoard: "Открыть доску",
	openDate: "Дата открытия",
	openInModal: "Открыть в модальном окне",
	openInNewTab: "Открыть в новой вкладке",
	openNavigation: "Открыть навигацию",
	openedDate: "Дата открытия",
	optional: "Необязательно",
	orClickToSelect: "или нажмите, чтобы выбрать файлы",
	order: "Заказ",
	orderNumber: "Номер заказа",
	orders: "Заказы",
	ordersCart: "График заказов",
	otAfterWork: "Сверхурочные после работы",
	otBeforeWork: "Сверхурочные до работы",
	otHours: "OT часы",
	otRate: "Ставка OT",
	otherBenefits: "Прочие льготы",
	otherDeductions: "Прочие удержания",
	otherInsurance: "Прочее страхование",
	outOfStock: "Нет в наличии",
	overdue: "Просрочено",
	overtime: "Сверхурочные",
	overtimeComment: "Комментарий к сверхурочным",
	overtimeDays: "Дни переработки",
	overtimeHours: "Часы переработки",
	overtimeRate: "Ставка переработки",
	overtimeSummary: "Сводка переработки",
	overtimeTotal: "Итого переработки",
	overview: "Обзор",
	owner: "Владелец",
	ownership: "Собственность",
	pageNotFound: "Страница не найдена",
	pageNotFoundDescription:
		"Упс! Страница, которую вы ищете, не существует или была перемещена. Возможно, она была удалена, переименована или временно недоступна.",
	pages: "Страницы",
	paid: "Оплачено",
	paidStatus: "Статус оплаты",
	paidTimeOff: "Оплачиваемый отпуск",
	paidTimeOffDays: "Дни оплачиваемого отпуска",
	parent: "Родитель",
	parentCategory: "Родительская категория",
	parentDepartment: "Родительский отдел",
	parentTask: "Родительская задача",
	parentType: "Тип родителя",
	parentUser: "Родительский пользователь",
	participant: "Участник",
	passportEndDate: "Дата окончания паспорта",
	passportImages: "Изображения паспорта",
	passportNo: "Паспорт №",
	passportStartDate: "Дата выдачи паспорта",
	password: "Пароль",
	pause: "Пауза",
	paused: "Приостановлено",
	payDate: "Дата выплаты",
	paymentMethod: "Метод оплаты",
	paymentMethods: "Способы оплаты",
	paymentSystem: "Платежная система",
	payrollBreakdown: "Детализация зарплаты",
	payrollCalcError: "Ошибка расчёта зарплаты.",
	payrollCalcHint:
		"Сотрудник и период обязательны. Нажмите, чтобы рассчитать и сохранить итоги зарплаты.",
	payrollCalcMissingFields: "Пожалуйста, выберите сотрудника, начало и конец периода.",
	payrollCommentsForEmployee: "Комментарии для сотрудника",
	payrollGeneratedFromAttendance: "Зарплата сформирована на основе посещаемости",
	payrollHealthInsurancePremium: "Медстрахование (премия)",
	payrollIndexLabel: "Номер",
	payrollIndexPlaceholder: "Номер",
	payrollInternalNotes: "Внутренние примечания",
	payrollNotesSection: "Примечания",
	payrollType: "Тип расчёта",
	payrollUsesHrSettings:
		"Сверхурочные, налоговые ставки и льготы по умолчанию (питание, транспорт, медстрахование) берутся из настроек HR (Система → Настройки HR).",
	pc: "Компьютер",
	pcHealth: "Состояние ПК",
	pcs: "ПК",
	pdf: "PDF",
	penalties: "Штрафы",
	pending: "Ожидает",
	pensionAmount: "Сумма пенсионных отчислений",
	pensionRate: "Ставка пенсионных отчислений",
	period: "Период",
	periodEnd: "Период окончания",
	periodStart: "Период начала",
	periud: "Период",
	permInput_calendarEvent_overlayCustomCalendars: "Пользовательские календари (фильтры)",
	permInput_calendarEvent_overlayIt: "IT-календари (гарантия ПК)",
	permInput_calendarEvent_overlayPeople: "Календари людей (HR)",
	permInput_calendarEvent_overlayReminders: "Слой напоминаний",
	permInput_calendarEvent_overlayTasks: "Задачи (слои приоритета)",
	permInput_calendarEvent_overlayTickets: "Тикеты (сроки по доменам)",
	permInput_chat_attachFile: "Прикрепление файлов",
	permInput_chat_calling: "Голосовые звонки",
	permInput_chat_pin: "Закрепление сообщений",
	permInput_chat_searchFiles: "Поиск в файлах",
	permInput_chat_searchMessages: "Поиск в сообщениях",
	permInput_chat_sendMessage: "Отправка сообщений",
	permInput_chat_star: "Отмечать сообщения",
	permInput_chat_videoCalling: "Видеозвонки",
	permModuleCrud_download: "Загрузка календаря (импорт .ics)",
	permModuleCrud_upload: "Выгрузка календаря (экспорт .ics)",
	permanentDelete: "Удалить навсегда?",
	permission: "Разрешение",
	permissions: "Разрешения",
	persons: "Люди",
	phone: "Телефон",
	photo: "Фото",
	photos: "Фотографии",
	pickEmoji: "Выберите эмодзи",
	pinnedMessages: "Закрепленные сообщения",
	placed: "Размещено",
	placedState: "Состояние размещения",
	placeholder: "Ввод на кирилице",
	platformDashboard: "Панель управления платформой",
	platformSpecificSettings: "Настройки, специфичные для платформы",
	platforms: "Платформы",
	audioPlaybackSpeed: "Скорость воспроизведения: {rate}. Нажмите, чтобы изменить.",
	playbackMute: "Выключить звук",
	playbackUnmute: "Включить звук",
	playbackVoiceMessage: "Голосовое сообщение",
	playbackVideoMessage: "Видеосообщение",
	previewVoiceMessage: "Прослушать голосовое сообщение",
	play: "Воспроизвести",
	playStatus: "Статус воспроизведения",
	playing: "Воспроизведение",
	playingComposition: "Воспроизведение композиции",
	playingHistory: "История воспроизведения",
	playlist: "Плейлист",
	playlistStatistics: "Статистика плейлистов",
	playlistsWithAds: "плейлисты с рекламой",
	playlistsWithoutAds: "плейлисты без рекламы",
	podcast: "Подкаст",
	podcastStreams: "потоки подкастов",
	podcasts: "Подкасты",
	ports: "порты",
	position: "Должность",
	positionReviewDate: "Дата пересмотра должности",
	preDefinedFilters: "Предопределенные фильтры",
	present: "Присутствует",
	preview: "Предпросмотр",
	previous: "Предыдущий",
	previousStep: "Предыдущий шаг",
	price: "Цена",
	priceB2b: "Цена Корпоративный",
	priceBasic: "Базовая цена",
	priceGroup1: "Ценовая группа 1",
	priceGroup2: "Ценовая группа 2",
	priceGroup3: "Ценовая группа 3",
	priceLists: "Прайс-листы",
	printedCount: "Количество распечаток",
	printer: "Принтер",
	printers: "Принтеры",
	priority: "Приоритет",
	priorityDescription: "Описание приоритета",
	private: "Частный",
	privateChat: "Приватный чат",
	privateChatDescription:
		"Только выбранные пользователи могут видеть этот чат и присоединиться к нему",
	problem: "Проблема",
	problemDescription: "Описание проблемы",
	problemGroup: "Группа проблем",
	problemGroupSupervisorsPlaceholder:
		"Пользователи, ответственные за обработку заявок в этой группе проблем",
	problemGroupSupervisorsTab: "Супервайзеры",
	processTime: "Время обработки",
	processing: "Обработка",
	progress: "Прогресс",
	product: "Продукт",
	productCare: "Уход за продуктом",
	products: "Продукты",
	productsLinked: "Связанные продукты",
	project: "Проект",
	projectChanges: "Изменения проекта",
	projectDeadline: "Срок проекта",
	projectDetails: "Детали проекта",
	projectEndDate: "Дата окончания проекта",
	projectID: "ID проекта",
	projectPartition: "Раздел проекта",
	projectPrice: "Цена проекта",
	projectPrice2: "Цена проекта",
	projectStartDate: "Дата начала проекта",
	projectType: "Тип проекта",
	projectTypes: "Типы проектов",
	projects: "Проекты",
	promoCode: "Промокод",
	promoCodes: "Промокоды",
	promoCodesAndCertificates: "Промокоды и сертификаты",
	promotions: "Акции",
	propertyNumber: "Номер свойства",
	providing: "Предоставление",
	punchActivity: "Отметки прихода/ухода",
	pto: "Оплачиваемый отпуск",
	partial: "Частично",
	quantity: "Количество",
	radioDashboard: "Панель управления радио",
	radioManagementOverview: "Обзор управления радио-трансляцией",
	radioStatistics: "Статистика радио",
	raises: "Повышения",
	ram: "ОЗУ",
	rate: "Показатель",
	rating: "Рейтинг",
	readOnly: "Только чтение",
	readOnlyChatNotice:
		"Этот чат доступен только для чтения участникам. Писать сообщения могут только администраторы.",
	readyToGetStarted: "Готовы начать",
	recalculatePayroll: "Пересчитать зарплату",
	recentClients: "Недавние клиенты",
	recentContent: "Недавний контент",
	recentMessages: "Недавние сообщения",
	recentOrders: "Последние заказы",
	recentTickets: "Последние билеты",
	recentTracks: "Недавние треки",
	refresh: "Обновить",
	registeredAddress: "Зарегистрированный адрес",
	regularHours: "Обычные часы",
	regularHoursHrScheduleHint:
		"Автозаполнение из настроек HR: рабочие дни в периоде × часов в день. Можно редактировать.",
	regularPlaylists: "Обычные плейлисты",
	relatedList: "Связанный список",
	relatedObjects: "Связанные объекты",
	relatedProducts: "Связанные товары",
	relatedTasks: "Связанные задачи",
	relations: "Отношения",
	remainingVacation: "Оставшийся отпуск",
	remote: "Удаленно",
	remoteWorkDays: "Дни удалённой работы",
	remove: "Удалить",
	removeFromList: "Удалить из списка",
	removeItem: "Удалить элемент",
	removed: "Удалено",
	reopen: "Восстановить",
	replaceableProduct: "Заменяемый продукт",
	replaceableProducts: "Заменяемые товары",
	replied: "Отвечено",
	reply: "Ответить",
	request: "Запрос",
	requestedForUser: "Запрошено для",
	reset: "Збросить",
	responseTimeDistribution: "Распределение времени ответа",
	responsible: "Ответственный",
	responsibleAndUsers: "Ответственные и пользователи",
	restoreSelected: "Восстановить выбранные",
	restored: "Восстановлено",
	returning: "Возвращающиеся",
	revenue: "Доход",
	revenueOverview: "Обзор доходов",
	review: "Обзор",
	rightNow: "Прямо сейчас",
	role: "Роль",
	rom: "ПЗУ",
	room: "Комната",
	routers: "Маршрутизаторы",
	rpaPrice: "Стоимость работы отдела РПА",
	ruleName: "Название правила",
	salary: "Зарплата",
	salaryReviewDate: "Дата пересмотра зарплаты",
	sale: "Распродажа",
	forSale: "На продажу",
	forBuying: "На закупку",
	productsForBuying: "Товары для покупки",
	productsForSelling: "Товары для продажи",
	supplier: "Поставщик",
	customers: "Клиенты",
	store: "Магазины",
	stores: "Магазины",
	shopping: "Закупки",
	salePrice: "Цена продажи",
	salesBreakdownByCategory: "Распределение продаж по категориям",
	salesPerformanceOverTime: "Динамика продаж",
	sat: "Суббота",
	save: "Сохранить",
	saveChanges: "Сохранить",
	saveComment: "Сохранить комментарий",
	saved: "Сохранено",
	schedulingDisabled: "Планирование отключено",
	schedulingEnabled: "Планирование включено",
	schedulingRules: "Правила расписания",
	search: "Поиск",
	searchByNameOrId: "Поиск по имени или ID…",
	searchChat: "Поиск чата...",
	searchChatGroups: "Поиск групповых чатов...",
	searchConversations: "Поиск конвертаций...",
	searchResults: "Результаты поиска",
	searchUsers: "Поиск пользователей...",
	secondary: "Второстепенный",
	seconds: "секунды",
	securityAcknowledge: "Подтвердить",
	securityActions: "Действия",
	securityActiveBadge: "Активна",
	securityActiveSessions: "Активные сессии",
	securityActivityStatClicks: "Клики",
	securityActivityStatKeys: "Клавиши",
	securityActivityStatMoves: "Движения",
	securityActivityTimeline: "Хронология активности",
	securityAdminNotes: "Заметки админа",
	securityAdminNotesDevice: "Внутренние заметки об устройстве...",
	securityAgentHeartbeat: "Пульс агента",
	securityAlertClipPlural: "клипов по оповещению на этой странице",
	securityAlertClipSingular: "клип по оповещению на этой странице",
	securityAlertCount: "оповещ.",
	securityAlertCountPlural: "оповещений",
	securityAlertDrawerNoMedia:
		"К этому оповещению пока не привязаны медиа. Агенту нужен FFmpeg для записи и загрузки. В Windows FFmpeg в PATH или FFMPEG_PATH. Смотрите журнал агента.",
	securityAlertDrawerVideoFailed:
		"Команда записи видео отправлена, но материал не загружен. Возможна ошибка агента — проверьте журнал на устройстве.",
	securityAlertDrawerVideoPending:
		"Видео записывается и скоро появится здесь. Агент на устройстве снимает и загружает материал.",
	securityAlertRecordings: "Записи по оповещению",
	securityAlertRecordingsOnly: "Только записи по оповещениям",
	securityAlertSt_acknowledged: "подтв.",
	securityAlertSt_false_positive: "ложн.",
	securityAlertSt_open: "открыт",
	securityAlertSt_resolved: "решено",
	securityAlertsTitle: "Оповещения безопасности",
	securityAllDevices: "Все устройства",
	securityAllEventTypes: "Все типы",
	securityAllRules: "Все правила",
	securityAllSeverities: "Все уровни",
	securityAllStatuses: "Все статусы",
	securityAppProcessTracking: "Приложения / процессы",
	securityAppTracking: "Приложения",
	securityAppUsageToday: "Использование приложений сегодня (мин.)",
	securityAssignedUser: "Назначенный пользователь",
	securityBadgeAlertText: "ТРЕВОГА",
	securityBadgeApp: "прил.",
	securityBadgeApps: "Приложения",
	securityBadgeCapture: "захват",
	securityBadgeFiles: "Файлы",
	securityBadgeOff: "выкл",
	securityBadgeScr: "скрин",
	securityBadgeScreenshot: "Снимок",
	securityBadgeVideo: "Видео",
	securityBadgeWeb: "Веб",
	securityCapture: "Захват",
	securityCaptureEnabledMaster: "Захват включён (главный)",
	securityCaptureEverySeconds: "Интервал снимков (сек)",
	securityCaptureMasterSwitch: "Захват включён (главный переключатель)",
	securityCaptureModes: "Режимы захвата",
	securityCaptureOffAlertBody:
		"Захват явно отключён на устройстве, переопределяя политику. Оповещения создаются, но снимки и видео не записываются.",
	securityCaptureOffAlertTitle: "Переопределение захвата: ВЫКЛ",
	securityCaptureRecorded: "Захват записан",
	securityCaptureWhenOnDesc: "При включении возможны снимки и видео; выключение отключает оба",
	securityChartMinutes: "минут",
	securityChartVisits: "визитов",
	securityClearFilters: "Сбросить фильтры",
	securityClickLeft: "Л",
	securityClickMiddle: "С",
	securityClickPlain: "клик",
	securityClickRight: "П",
	securityClientsAccuracyApproximateOnly: "Точность: только приблизительно",
	securityClientsActions: "Действия",
	securityClientsActivity: "Активность",
	securityClientsAny: "Любой",
	securityClientsApproximateGeo: "Приблизительная гео",
	securityClientsApproximateGeoOnly: "Только приблизительная гео",
	securityClientsApproximateLocationUnavailable: "Приблизительное местоположение недоступно",
	securityClientsApproximateOriginsOnly:
		"Только приблизительное происхождение. Маркеры сгруппированы для приватности и производительности.",
	securityClientsBlocked: "Заблокировано",
	securityClientsBlockedIp: "Заблокированный IP",
	securityClientsBlockedRequestPressure: "Давление заблокированных запросов",
	securityClientsBrowser: "Браузер",
	securityClientsCardAcrossLast: "За последние",
	securityClientsCardActiveDenyEntriesSubtitle:
		"Активные запретные записи, применяемые на уровне API",
	securityClientsCardActiveSessions: "Активные сессии",
	securityClientsCardApproximateGeographiesSubtitle: "Приблизительная география на карте",
	securityClientsCardBlockedIpRules: "Правила блокировки IP",
	securityClientsCardConnectedDevices: "Подключенные устройства",
	securityClientsCardCountries: "Страны",
	securityClientsCardDistinctUsersSubtitle:
		"Уникальные пользователи в активных или подключенных сессиях",
	securityClientsCardLightweightRiskSignalsSubtitle:
		"Легковесные риск-сигналы на основе локации, устройства и политик",
	securityClientsCardMinuteActivityWindow: "минут окна активности",
	securityClientsCardSuspiciousSessions: "Подозрительные сессии",
	securityClientsCardUsersOnline: "Пользователи онлайн",
	securityClientsCardWithLiveSocketPresence: "с активным socket-подключением",
	securityClientsClusters: "Кластеры",
	securityClientsConnectionMap: "Карта подключений",
	securityClientsCountry: "Страна",
	securityClientsCurrent: "Текущая",
	securityClientsDays: "дней",
	securityClientsDenied: "Отклонено",
	securityClientsDevice: "Устройство",
	securityClientsDeviceBrowserOnOs: "{browser} на {os}",
	securityClientsDevices: "Устройства",
	securityClientsDisconnectAll: "Отключить все",
	securityClientsDisconnectAllSessionsForCurrentUserText:
		"Все остальные сессии вашей учетной записи будут отозваны. Текущая сессия останется активной.",
	securityClientsDisconnectAllSessionsForTargetUserText:
		"Все активные сессии этого пользователя будут немедленно отозваны.",
	securityClientsDisconnectAllSessionsForUserTitle: "Отключить все сессии этого пользователя?",
	securityClientsDisconnectAllUserSessions: "Отключить все сессии пользователя",
	securityClientsDisconnectSession: "Отключить сессию",
	securityClientsDisconnectThisSessionText:
		"Выбранная клиентская сессия будет немедленно принудительно завершена.",
	securityClientsDisconnectThisSessionTitle: "Отключить эту сессию?",
	securityClientsExpires: "Истекает",
	securityClientsFailedToLoadDataTitle: "Не удалось загрузить данные клиентов",
	securityClientsFilterActiveAndRecent: "Активные + недавние",
	securityClientsFiltersDescription:
		"Фильтруйте по активности, географии, устройствам, статусу блокировки сети и простым риск-сигналам.",
	securityClientsFiltersTitle: "Фильтры и поиск",
	securityClientsFirstSeen: "Первое появление",
	securityClientsLastActive: "Последняя активность",
	securityClientsLastDenied: "Последний отказ",
	securityClientsLiveInventoryDescription:
		"Используйте группировку по устройствам для быстрых паттернов или вид сессий для точных действий по пользователю и IP.",
	securityClientsLiveInventoryTitle: "Живой реестр клиентов",
	securityClientsLiveMonitoring: "Живой мониторинг",
	securityClientsLiveSocketUpdates: "Живые socket-обновления",
	securityClientsLocationPrivacyNote:
		"Метки местоположения используют приблизительную IP-геолокацию и могут указывать на шлюз, интернет-провайдера, VPN или точку выхода офиса, а не на точное положение устройства.",
	securityClientsMapFailedToLoad: "Не удалось загрузить карту",
	securityClientsMapProviderNotConfigured: "Провайдер карты не настроен",
	securityClientsMostActiveUsers: "Самые активные пользователи",
	securityClientsNetworkAndLocation: "Сеть и местоположение",
	securityClientsNoActiveUsersForFilters:
		"Для этого набора фильтров активные пользователи не найдены.",
	securityClientsNoApproximateGeoPoints:
		"Для текущего набора фильтров пока нет приблизительных геоточек.",
	securityClientsNoBlockedRequestActivity:
		"За последние 24 часа не зафиксировано активности заблокированных запросов.",
	securityClientsNoDataYet: "Пока нет данных.",
	securityClientsNoEmail: "Нет email",
	securityClientsNoMatchingResults: "Нет сессий или устройств, соответствующих текущим фильтрам.",
	securityClientsNoSuspiciousPatterns: "Простые эвристики пока не выявили подозрительных шаблонов.",
	securityClientsNoUsersAcrossMultipleDevices:
		"Сейчас нет пользователей, работающих с нескольких устройств.",
	securityClientsNotBlocked: "Не заблокирован",
	securityClientsOf: "из",
	securityClientsOn: "на",
	securityClientsOperatingSystem: "Операционная система",
	securityClientsPrimaryUser: "Основной пользователь",
	securityClientsRecentActivityWindow: "Окно недавней активности:",
	securityClientsRefreshLiveData: "Обновить живые данные",
	securityClientsReset: "Сбросить",
	securityClientsRetryLoading: "Повторить загрузку",
	securityClientsRisk: "Риск",
	securityClientsRiskHigh: "Высокий",
	securityClientsRiskLow: "Низкий",
	securityClientsRiskMedium: "Средний",
	securityClientsRiskNormal: "Нормальный",
	securityClientsRiskSignals: "Риск-сигналы",
	securityClientsSignalBlockedAttemptsDescription:
		"{count} запросов отклонено из-за политики блокировки IP.",
	securityClientsSignalBlockedAttemptsTitle: "Заблокированные IP-запросы за последние 24 часа",
	securityClientsSignalBlockedIpSessionsDescription:
		"{count} отслеживаемых сессий связаны с активной записью политики блокировки IP.",
	securityClientsSignalBlockedIpSessionsTitle: "Сессии всё ещё видны с заблокированных IP",
	securityClientsSignalManyDevicesDescription:
		"Зафиксировано на {count} разных устройствах в окне активного мониторинга.",
	securityClientsSignalManyDevicesTitle: "У {user} много устройств",
	securityClientsSignalMultiCountryDescription:
		"Недавняя активность охватывает {count} стран за последние 24 часа.",
	securityClientsSignalMultiCountryTitle: "{user} активен в нескольких странах",
	securityClientsSignalSeverityCritical: "Критический",
	securityClientsSignalSeverityInfo: "Информация",
	securityClientsSignalSeverityWarning: "Предупреждение",
	securityClientsSearchPlaceholder: "Поиск по пользователю, email, IP-адресу или устройству",
	securityClientsSecurityActionFailed: "Не удалось выполнить действие безопасности",
	securityClientsSecurityCenter: "Центр безопасности",
	securityClientsSecurityUpdated: "Безопасность обновлена",
	securityClientsSessionDisconnected: "Сессия отключена.",
	securityClientsSessions: "Сессии",
	securityClientsSetEnvToEnableMapPrefix: "Укажите",
	securityClientsSetEnvToEnableMapSuffix: "для включения живой геокарты.",
	securityClientsSharedDevice: "Общее устройство",
	securityClientsShowing: "Показано",
	securityClientsStatus: "Статус",
	securityClientsStatusActive: "Активный",
	securityClientsStatusConnected: "Подключен",
	securityClientsStatusRecent: "Недавний",
	securityClientsStatusRevoked: "Отозван",
	securityClientsStatusStale: "Устаревший",
	securityClientsSubtitle:
		"Отслеживайте все подключенные и недавно активные клиентские сессии, понимайте их происхождение, рано выявляйте рисковые шаблоны и сразу применяйте меры в модуле безопасности.",
	securityClientsSuspicious: "Подозрительный",
	securityClientsSuspiciousSessions: "Подозрительные сессии",
	securityClientsSyncingLiveChanges: "Синхронизация изменений...",
	securityClientsTitle: "Клиенты безопасности",
	securityClientsTopBrowsers: "Топ браузеров",
	securityClientsTopCountries: "Топ стран",
	securityClientsTopOperatingSystems: "Топ ОС",
	securityClientsUnableToDisconnectSelectedSession: "Не удалось отключить выбранную сессию.",
	securityClientsUnableToDisconnectUserSessions: "Не удалось отключить сессии пользователя.",
	securityClientsUnableToLoadDashboard: "Не удалось загрузить панель Security Clients.",
	securityClientsUnableToLoadGoogleMaps: "Сейчас не удается загрузить Google Maps.",
	securityClientsUnknownBrowser: "Неизвестный браузер",
	securityClientsUnknownDevice: "Неизвестное устройство",
	securityClientsUnknownIp: "Неизвестный IP",
	securityClientsUnknownOs: "Неизвестная ОС",
	securityClientsUnknownUser: "Неизвестный пользователь",
	securityClientsUnknownUserInitial: "П",
	securityClientsUpdated: "Обновлено",
	securityClientsUser: "Пользователь",
	securityClientsUserSessionsDisconnected: "Сессии пользователя отключены.",
	securityClientsUsers: "Пользователи",
	securityClientsUsersSeenOnDevice: "пользователей замечено на устройстве",
	securityClientsUsersWithMultipleDevices: "Пользователи с несколькими устройствами",
	securityClientsViewUserSecurity: "Открыть безопасность пользователя",
	securityClipWord: "Клип",
	securityConnectedDevices: "Подключённые устройства",
	securityCreated: "Создано",
	securityDeleteDevice: "Удалить устройство",
	securityDeleteDeviceConfirm: "Вы уверены, что хотите удалить",
	securityDeleteDeviceNote:
		"Это удалит только запись устройства безопасности. Профиль ПК в IT не будет затронут.",
	securityDeleteDeviceTitle: "Удалить устройство безопасности",
	securityDeleteMedia: "Удалить",
	securityDeletePolicyConfirm: "Удалить эту политику?",
	securityDevice: "Устройство",
	securityDeviceFallback: "Устройство",
	securityDeviceIdLabel: "ID устройства",
	securityDeviceNotFound: "Устройство не найдено",
	securityDeviceSettings: "Настройки устройства",
	securityDeviceSettingsHint:
		"Переопределяет политику для этого устройства. Если не задано — наследуется из политики.",
	securityDevicesBreadcrumb: "Устройства",
	securityDevicesTitle: "Устройства безопасности",
	securityDevicesWithAlerts: "Устройства с оповещениями",
	securityDividerCapture: "Захват",
	securityDividerNotes: "Заметки",
	securityDividerTracking: "Отслеживание",
	securityDuration: "Длительность",
	securityEg15: "напр. 15",
	securityEg30: "напр. 30",
	securityEg300: "напр. 300",
	securityEg5: "напр. 5",
	securityEg60: "напр. 60",
	securityEnabled: "Включено",
	securityEnd: "Конец",
	securityEventFlushSeconds: "Сброс событий (сек)",
	securityEventsCount: "событие",
	securityEventsCountPlural: "событий",
	securityEvtAppProcess: "Приложение / процесс",
	securityEvtAppUsage: "Использование приложений",
	securityEvtFileEvent: "Событие файла",
	securityEvtHeartbeat: "Пульс",
	securityEvtInputActivity: "Активность ввода",
	securityEvtKeystroke: "Нажатие клавиши",
	securityEvtMouseClick: "Клик мыши",
	securityEvtSessionEnd: "Конец сессии",
	securityEvtSessionStart: "Начало сессии",
	securityEvtSystemBoot: "Запуск системы",
	securityEvtSystemShutdown: "Выключение системы",
	securityEvtUsb: "Событие USB",
	securityEvtUserLogin: "Вход пользователя",
	securityEvtUserLogout: "Выход пользователя",
	securityEvtWebVisit: "Веб-визит",
	securityEvtWorkstationLock: "Экран заблокирован",
	securityEvtWorkstationUnlock: "Экран разблокирован",
	securityFailedLoadOverview: "Не удалось загрузить обзор безопасности",
	securityFailedSavePolicy: "Не удалось сохранить политику",
	securityFalsePositiveBtn: "Ложное срабатывание",
	securityFileEventTracking: "События файлов",
	securityFilterByDate: "Фильтр по дате",
	securityFilterDateRange: "Фильтр по диапазону дат",
	securityFilteredSuffix: "(отфильтр.)",
	securityFps: "Кадр/сек",
	securityHostname: "Имя хоста",
	securityInputActivityCounts: "Активность ввода (счётчики)",
	securityInputKeystrokeClickTracking: "Отслеживание нажатий и кликов",
	securityInputModeActivityCountsShort: "Только активность — счётчики",
	securityInputModeActivityOnly: "Только активность (счётчики)",
	securityInputModeDisabled: "Отключено",
	securityInputModeDisabledShort: "Откл. — без метрик ввода",
	securityInputModeEventsOnly: "Только события",
	securityInputModeEventsStream: "Только события — поток",
	securityInputModeFullDetail: "Полная детализация (нажатия + клики)",
	securityInputModeFullKeystrokes: "Полная детализация — нажатия и клики",
	securityInputModeShort: "Режим ввода",
	securityInputTrackingMode: "Режим отслеживания ввода",
	securityInternalNotesPlaceholder: "Внутренние заметки...",
	securityIpPolicyActions: "Действия",
	securityIpPolicyActive: "Активно",
	securityIpPolicyAllow: "Разрешить",
	securityIpPolicyAppliesToAllIps: "Применить это окно входа ко всем IP-адресам",
	securityIpPolicyAllowRuleSaved: "Разрешающее правило сохранено",
	securityIpPolicyAllowRuleSavedMessage: "Разрешающее правило сохранено.",
	securityIpPolicyBlock: "Блокировать",
	securityIpPolicyBlockIp: "Заблокировать IP",
	securityIpPolicyCreatedBy: "Создано",
	securityIpPolicyCurrentEntries: "Текущие записи",
	securityIpPolicyDeactivate: "Деактивировать",
	securityIpPolicyDeactivateAllowRuleText:
		"Этот IP-адрес больше не будет обходить подходящие правила блокировки.",
	securityIpPolicyDeactivateAllowRuleTitle: "Деактивировать это разрешающее правило?",
	securityIpPolicyEntryDeactivatedMessage: "Запись IP-политики деактивирована.",
	securityIpPolicyExpires: "Истекает",
	securityIpPolicyExpiresAt: "Истекает",
	securityIpPolicyExpiresAtPlaceholder: "Необязательное временное истечение",
	securityIpPolicyFailedToLoadTitle: "Не удалось загрузить IP-политику",
	securityIpPolicyFailedToSaveTitle: "Не удалось сохранить IP-политику",
	securityIpPolicyFailedToUnblockTitle: "Не удалось разблокировать IP",
	securityIpPolicyGlobalApiEnforcement: "Глобальное применение в API",
	securityIpPolicyInactive: "Неактивно",
	securityIpPolicyIntroText:
		"Записи сопоставляются с нормализованным IP-адресом клиента. Данные о местоположении в системе являются приблизительными и не должны считаться точными.",
	securityIpPolicyIp: "IP",
	securityIpPolicyIpAddress: "IP-адрес",
	securityIpPolicyIpAddressBlocked: "IP-адрес заблокирован.",
	securityIpPolicyIpAddressUnblocked: "IP-адрес разблокирован.",
	securityIpPolicyIpBlocked: "IP заблокирован",
	securityIpPolicyIpBlockedMessage: "IP-адрес добавлен в политику блокировки.",
	securityIpPolicyIpUnblocked: "IP разблокирован",
	securityIpPolicyLastMatched: "Последнее совпадение",
	securityIpPolicyMatches: "Срабатывания",
	securityIpPolicyNewEntry: "Новая запись политики",
	securityIpPolicyNoEntriesFound: "Записи IP-политики не найдены.",
	securityIpPolicyNotes: "Заметки",
	securityIpPolicyNotesPlaceholder: "Операционные заметки для администраторов",
	securityIpPolicyOperationalNotesOptional: "Операционные заметки (необязательно)",
	securityIpPolicyReason: "Причина",
	securityIpPolicyReasonOptional: "Причина (необязательно)",
	securityIpPolicyReasonPlaceholder: "Повторяющиеся подозрительные попытки входа",
	securityIpPolicyRemoveIpBlockText:
		"Этот IP-адрес больше не будет блокироваться политикой платформы.",
	securityIpPolicyRemoveIpBlockTitle: "Удалить эту блокировку IP?",
	securityIpPolicyRuleType: "Тип правила",
	securityIpPolicySaveEntry: "Сохранить запись политики",
	securityIpPolicyShowInactive: "Показать неактивные",
	securityIpPolicyScope: "Область",
	securityIpPolicyScopeApi: "Весь API",
	securityIpPolicyScopeLogin: "Только вход",
	securityIpPolicyStatus: "Статус",
	securityIpPolicyStarts: "Начинается",
	securityIpPolicyStartsAt: "Начинается",
	securityIpPolicyStartsAtPlaceholder: "Необязательное время начала правила",
	securityIpPolicyTitle: "Политика блокировки и разрешения IP",
	securityIpPolicyLockdownTitle: "Блокировать все внешние входы",
	securityIpPolicyLockdownDesc:
		"Когда включено, пользователи без правила разрешения входа могут входить только с настроенного офисного IP. Добавьте офисные IP ниже или используйте правила разрешения входа без привязки пользователей.",
	securityIpPolicyLockdownOn: "Вкл",
	securityIpPolicyLockdownOff: "Выкл",
	securityIpPolicyLockdownSavedTitle: "Блокировка обновлена",
	securityIpPolicyLockdownOnMessage: "Внешние входы теперь ограничены одобренными офисными IP.",
	securityIpPolicyLockdownOffMessage:
		"Неограниченные пользователи теперь могут входить откуда угодно.",
	securityIpPolicyOfficeIpsTitle: "Офисные IP",
	securityIpPolicyOfficeIpsDesc:
		"Сетевые адреса, считающиеся офисом. При включённой блокировке входы с этих IP разрешены; все остальные IP блокируются, если пользователь не в списке доверенных пользователей.",
	securityIpPolicyOfficeIpsPh: "Введите офисный IP и нажмите Enter",
	securityIpPolicyOfficeIpsSave: "Сохранить офисные IP",
	securityIpPolicyOfficeIpsSavedTitle: "Офисные IP обновлены",
	securityIpPolicyOfficeIpsSavedMessage:
		"Офисные сетевые адреса сохранены. Блокировка будет считать их офисными локациями.",
	securityIpPolicyTrustedUsersTitle: "Пользователи с доступом из офиса и извне",
	securityIpPolicyTrustedUsersDesc:
		"Эти пользователи могут входить откуда угодно — из офиса или извне — даже при включённой блокировке. Жёсткие блокировки IP по-прежнему действуют.",
	securityIpPolicyTrustedUsersPh: "Выберите доверенных пользователей",
	securityIpPolicyTrustedUsersSave: "Сохранить доверенных пользователей",
	securityIpPolicyTrustedUsersSavedTitle: "Доверенные пользователи обновлены",
	securityIpPolicyTrustedUsersSavedMessage:
		"Эти пользователи теперь могут входить из офиса и извне.",
	securityIpPolicyOfficeBindingTitle: "Привязка офисного доступа",
	securityIpPolicyOfficeBindingDesc:
		"Привяжите выбранных пользователей к этим IP и необязательному временному окну. Эти пользователи смогут входить только отсюда и в эти часы.",
	securityIpPolicyAdditionalIps: "Дополнительные IP",
	securityIpPolicyAdditionalIpsDesc:
		"Дополнительные одобренные IP для этого правила, помимо основного IP выше.",
	securityIpPolicyAdditionalIpsPh: "Введите IP и нажмите Enter",
	securityIpPolicyAddIp: "Добавить IP",
	securityIpPolicyAppliesToAllUsers: "Применить ко всем пользователям",
	securityIpPolicyAppliesToAllUsersDesc:
		"Каждый пользователь должен входить с IP и в окне этого правила. Равнозначно ограничению для всего офиса.",
	securityIpPolicySelectedUsers: "Выбранные пользователи",
	securityIpPolicySelectedUsersDesc:
		"Эти пользователи могут входить только с IP этого правила в разрешённое окно.",
	securityIpPolicySelectedUsersPh: "Выберите пользователей",
	securityIpPolicyRecurringWindowTitle: "Разрешённое временное окно (необязательно)",
	securityIpPolicyDaysOfWeek: "Разрешённые дни",
	securityIpPolicyDaysOfWeekDesc: "Оставьте пустым, чтобы разрешить каждый день.",
	securityIpPolicyDaysOfWeekPh: "Любой день",
	securityIpPolicyDailyStart: "С (ЧЧ:ММ)",
	securityIpPolicyDailyEnd: "До (ЧЧ:ММ)",
	securityIpPolicyTimezone: "Часовой пояс",
	securityIpPolicyDayMon: "Пн",
	securityIpPolicyDayTue: "Вт",
	securityIpPolicyDayWed: "Ср",
	securityIpPolicyDayThu: "Чт",
	securityIpPolicyDayFri: "Пт",
	securityIpPolicyDaySat: "Сб",
	securityIpPolicyDaySun: "Вс",
	securityIpPolicyUsersColumn: "Пользователи",
	securityIpPolicyWindowColumn: "Окно времени",
	securityIpPolicyAllUsers: "Все пользователи",
	securityIpPolicyAllIps: "Все IP",
	securityIpPolicyInvalidTimeWindow: "Время должно быть в формате ЧЧ:ММ.",
	securityIpPolicyTimeWindowBothRequired:
		"Укажите начало и конец времени или оставьте оба пустыми.",
	securityIpPolicyType: "Тип",
	securityIpPolicyUnableToBlockIpAddress: "Не удалось заблокировать этот IP-адрес.",
	securityIpPolicyUnableToLoadEntries: "Не удалось загрузить записи IP-политики.",
	securityIpPolicyUnableToSaveEntry: "Не удалось сохранить запись IP-политики.",
	securityIpPolicyUnableToUnblockIpAddress: "Не удалось разблокировать этот IP-адрес.",
	securityIpPolicyUnableToUpdateEntry: "Не удалось обновить запись IP-политики.",
	securityIpPolicyUnblock: "Разблокировать",
	securityIpPolicyUnblockIp: "Разблокировать IP",
	securityIpPolicyUnblockThisIpText:
		"Соответствующее правило блокировки будет отключено, и IP больше не будет отклоняться политикой.",
	securityIpPolicyUnblockThisIpTitle: "Разблокировать этот IP?",
	securityIpPolicyWarningText:
		"Заблокированные IP запрещают доступ по всему API, а не только при входе. Используйте временное истечение, когда краткосрочная блокировка безопаснее постоянной.",
	securityKeyCharPrefix: "клав.:",
	securityLastSeen: "Последняя активность",
	securityLatestClip: "Последний клип",
	securityLinkedItPc: "Связанный ПК (IT):",
	securityLiveLoadingSub:
		"Подключение к агенту — предпросмотр экрана появится через несколько секунд.",
	securityLiveOfflineHint: "Устройство офлайн — для просмотра нужен подключённый агент.",
	securityLivePressStart: "Нажмите «Начать просмотр», чтобы открыть поток.",
	securityLiveScreenAlt: "Экран в реальном времени",
	securityLiveStatusLive: "ЭФИР",
	securityLiveStatusStandby: "Ожидание",
	securityLiveStreamHint:
		"Поток: половина ширины и высоты кадра, до 10 кадр/с. Агент v1.4.0+ с зависимостью jimp.",
	securityLiveWaitingFrames: "Загрузка прямого эфира…",
	securityLoggedInSince: "В сети с",
	securityLoggedOutSince: "Последний выход",
	securityMediaPrefix: "Медиа",
	securityMediaTitle: "Медиа безопасности",
	securityMiddleClick: "сред. клик",
	securityModuleErrorTitle: "Ошибка модуля безопасности",
	securityName: "Название",
	securityNearbyScreenshots: "Ближайшие снимки",
	securityNever: "Никогда",
	securityNewMediaBadge: "новое",
	securityNewPolicy: "Новая политика",
	securityNoActivityEvents: "Нет событий активности",
	securityNoAlertRecordingsPage: "На этой странице нет записей по оповещениям",
	securityNoAlertsForDevice: "Нет оповещений для этого устройства",
	securityNoAlertsFound: "Оповещения не найдены",
	securityNoDevicesFound: "Устройства не найдены",
	securityNoEventsMatchFilter: "Нет событий по фильтру",
	securityNoOpenAlerts: "Нет открытых оповещений",
	securityNoPoliciesConfigured: "Политики не настроены. Создайте для начала мониторинга.",
	securityNoPreview: "Нет превью",
	securityNoRiskyDevices: "Нет рискованных устройств",
	securityNoScreenshotsFound: "Снимки не найдены",
	securityNoScreenshotsYet: "Снимки пока не сделаны",
	securityNoSessionsFound: "Сессии не найдены",
	securityNoSessionsRecorded: "Сессии не записаны",
	securityNoUserSession: "Нет сессии",
	securityNoUserSessionLiveHint:
		"ПК включён, но пользователь не вошёл. Прямой просмотр и скриншоты недоступны.",
	securityNoUserSessionTitle: "Пользователь не авторизован",
	securityNoVideoSegmentsFound: "Видеофрагменты не найдены",
	securityNoVideosYet: "Видеофрагменты пока отсутствуют",
	securityOS: "ОС",
	securityOnlineDevices: "Устройства в сети",
	securityOpenAlerts: "Открытые оповещения",
	securityOpenPcRecord: "Открыть запись ПК",
	securityOverrideOff: "ВЫКЛ",
	securityOverrideOn: "ВКЛ",
	securityOverridePrefix: "Переопределение:",
	securityOverviewTitle: "Обзор безопасности",
	securityPageOf: "стр.",
	securityPolActivityTrackingDivider: "Отслеживание активности",
	securityPolAfterHoursStart: "Начало внеурочного времени",
	securityPolAlertClipLength: "Длина клипа по оповещению (сек)",
	securityPolAlertScore: "Оценка оповещения (0–100)",
	securityPolAlertSeverity: "Важность оповещения",
	securityPolAlertVideoDivider: "Видеозапись по оповещению",
	securityPolAlertVideoInfo:
		"При срабатывании правила агент записывает один клип рабочего стола с настройками ниже. Длина и качество одинаковы для всех правил.",
	securityPolAllowedHoursDivider: "Разрешённые часы захвата",
	securityPolBadgeAlert: "Оповещение",
	securityPolBlockedApps: "Заблокированные приложения",
	securityPolBlockedAppsPh: "напр. telegram, discord, torrent",
	securityPolBlockedDomains: "Заблокированные домены",
	securityPolBlockedDomainsPh: "напр. torrent-site.com, telegram.org",
	securityPolBreadcrumbPolicies: "Политики",
	securityPolBulkThreshold: "Порог массовых операций с файлами (событий/пакет)",
	securityPolBulkThresholdDesc:
		"Число деструктивных файловых событий в одной пачке для срабатывания",
	securityPolCollectInputMetrics: "Собирать метрики активности ввода",
	securityPolCollectInputMetricsDesc:
		"Только счётчики событий мыши и клавиатуры (без содержимого нажатий)",
	securityPolCreateAlert: "Создать оповещение",
	securityPolCreateAlertDesc:
		"При совпадении правила создаётся оповещение (видео — настройки вкладки «Захват»)",
	securityPolDescription: "Описание",
	securityPolEditPolicy: "Изменить политику",
	securityPolEnableRule: "Включить правило",
	securityPolEventsRetention: "Хранение событий (дней)",
	securityPolEventsRetentionDesc: "Записи активности старше этого срока удаляются",
	securityPolExcludedDomains: "Исключённые домены",
	securityPolExcludedDomainsPh: "напр. online-banking.com",
	securityPolExcludedProcesses: "Исключённые имена процессов",
	securityPolExcludedProcessesPh: "напр. 1Password, Bitwarden",
	securityPolIgnoredAlertDevices: "Устройства, игнорируемые для оповещений",
	securityPolIgnoredAlertDevicesDesc:
		"Выбранные устройства продолжают отправлять активность, но правила политики не будут создавать для них оповещения безопасности или записи оповещений.",
	securityPolIgnoredAlertDevicesPh: "Искать и выбрать устройства для исключения из оповещений...",
	securityPolInputActivityCounts: "Только активность — счётчики мыши и клавиш",
	securityPolInputDisabledNoTrack: "Отключено — не отслеживать ввод",
	securityPolInputEventsCount: "Только события — только счётчики нажатий",
	securityPolInputFullDetail: "Полная детализация — нажатия и позиции кликов",
	securityPolInputModeLabel: "Режим отслеживания ввода",
	securityPolInputTrackingDivider: "Отслеживание ввода",
	securityPolMaskSensitive: "Скрывать чувствительные окна (менеджеры паролей, банки)",
	securityPolMaskSensitiveDesc: "Не делать снимки для исключённых приложений/окон",
	securityPolMaxFps: "Макс. кадр/сек",
	securityPolMediaRetention: "Хранение медиа (дней)",
	securityPolMediaRetentionDesc: "Снимки и видео старше этого срока удаляются",
	securityPolNewSecurityPolicy: "Новая политика безопасности",
	securityPolNotifyUsersDesc:
		"Выбранные пользователи получат уведомление в приложении при срабатывании любого правила этой политики.",
	securityPolNotifyUsersLabel: "Уведомлять администраторов при срабатывании политики",
	securityPolNotifyUsersPh: "Найдите и выберите пользователей для уведомления…",
	securityPolPolicyName: "Название политики",
	securityPolPolicyNamePh: "напр. Политика для разработчиков",
	securityPolPriority: "Приоритет",
	securityPolPriorityDesc: "Большее число = выше приоритет",
	securityPolRecordVideoOnAlert: "Записывать видео при оповещении",
	securityPolRecordVideoOnAlertDesc: "Если выкл., оповещения создаются, но видео не записывается",
	securityPolRuleAfterHoursDesc: "Срабатывает при активности вне заданных рабочих часов.",
	securityPolRuleAfterHoursLabel: "Активность вне рабочего времени",
	securityPolRuleBlockedAppDesc: "Срабатывает, когда пользователь открывает приложение из списка.",
	securityPolRuleBlockedAppLabel: "Заблокированное приложение",
	securityPolRuleBlockedDomainDesc: "Срабатывает при посещении домена из списка.",
	securityPolRuleBlockedDomainLabel: "Заблокированный домен",
	securityPolRuleBulkFileDesc:
		"Срабатывает при большом числе удалений, переименований или перемещений файлов за один пакет.",
	securityPolRuleBulkFileLabel: "Массовые операции с файлами",
	securityPolRuleUsbDesc: "Срабатывает при подключении USB-накопителя к устройству.",
	securityPolRuleUsbLabel: "Обнаружено USB-хранилище",
	securityPolRulesIntro:
		"Правила задают нарушение и оценку оповещения. При «Создать оповещение» создаётся тревога; видео — по вкладке «Захват» (одинаково для всех правил).",
	securityPolSavePolicy: "Сохранить политику",
	securityPolScope: "Область",
	securityPolScopeDepartment: "Отдел",
	securityPolScopeDevice: "Конкретные устройства",
	securityPolScopeGlobal: "Глобально — для всех устройств",
	securityPolScopeUser: "Конкретные пользователи",
	securityPolTabCapture: "Захват",
	securityPolTabPrivacy: "Конфиденциальность и исключения",
	securityPolTabRetention: "Хранение",
	securityPolTabRules: "Правила",
	securityPolTrackApps: "Отслеживать активные приложения",
	securityPolTrackFiles: "Отслеживать файловую активность",
	securityPolTrackWebsites: "Отслеживать посещения сайтов",
	securityPolTrackingMaster: "Отслеживание включено (главный переключатель)",
	securityPolTrackingMasterDesc: "При выкл. неактивны приложения, веб, файлы и ввод",
	securityPolVisibleNotice: "Показывать сотрудникам уведомление о мониторинге",
	securityPolVisibleNoticeDesc: "Показывает баннер о том, что мониторинг активен",
	securityPolWorkDayStart: "Начало рабочего дня (конец внеурочного)",
	securityPolWorkingHours: "Рабочие часы (необязательно)",
	securityPolWorkingHoursDesc:
		"Захват только в этом окне. Формат: ЧЧ:ММ-ЧЧ:ММ, напр. 09:00-18:00. Пусто = всегда.",
	securityPolWorkingHoursPh: "09:00-18:00",
	securityPoliciesCaptureHint:
		"Значки показывают, что включено. Чтобы включить или выключить скриншоты, видео, приложения, веб или файлы, откройте политику (карандаш) → вкладка «Захват».",
	securityPoliciesTitle: "Политики безопасности",
	securityPolicyDefaultBadge: "По политике",
	securityPriority: "Приоритет",
	securityQueued: "В очереди!",
	securityRecentOpenAlerts: "Недавние открытые оповещения",
	securityRecentScreenshots: "Недавние снимки экрана",
	securityRecordEverySeconds: "Запись каждые (сек)",
	securityRecordVideo30s: "Записать видео (30 с)",
	securityRefresh: "Обновить",
	securityResolution: "Разрешение",
	securityResolutionNotePlaceholder: "Примечание к решению (необязательно)",
	securityResolve: "Решить",
	securityRightClick: "ПКМ",
	securityRule: "Правило",
	securityRuleCode_AFTER_HOURS: "Вне рабочего времени",
	securityRuleCode_BLOCKED_APP: "Заблокированное приложение",
	securityRuleCode_BLOCKED_DOMAIN: "Заблокированный домен",
	securityRuleCode_BULK_FILE_EVENTS: "Массовые операции с файлами",
	securityRuleCode_USB_DETECTED: "Обнаружен USB",
	securitySaveSettings: "Сохранить настройки",
	securitySaved: "Сохранено",
	securityScope: "Область",
	securityScopeType_department: "Отдел",
	securityScopeType_device: "Устройство",
	securityScopeType_global: "Глобально",
	securityScopeType_user: "Пользователь",
	securityScreenshotAlt: "Снимок экрана",
	securityScreenshotOptionsBlank: "Параметры снимков (пусто = по политике)",
	securityScreenshots: "Снимки экрана",
	securityScreenshotsCount: "Снимки экрана",
	securityScreenshotsLabel: "Снимки экрана",
	securityScreenshotsToday: "Снимки экрана сегодня",
	securitySearch: "Поиск",
	securitySearchDevicesPlaceholder: "Поиск по имени, ID, пользователю...",
	securitySegmentLengthSeconds: "Длина сегмента (сек)",
	securitySelectedCount: "выбрано",
	securitySessionActive: "Активно",
	securitySessionIdle: "Простой",
	securitySessionLocked: "Экран заблокирован",
	securitySessionLockedCaptureHint: "Экран заблокирован — скриншоты и прямой просмотр недоступны.",
	securitySessionLockedLiveHint:
		"Пользователь заблокировал экран. Прямой просмотр, скриншоты и записи недоступны, пока экран заблокирован.",
	securitySessionLockedSince: "Заблокирован с",
	securitySessionLockedTitle: "Экран заблокирован",
	securitySessionNotFound: "Сессия не найдена",
	securitySessionTimeline: "Хронология сессии",
	securitySessionWord: "Сессия",
	securitySessionsTitle: "Сессии",
	securitySettingsDrawerTitle: "Настройки",
	securitySettingsOverrideHint:
		"Переопределяют политику только для этого устройства. Оставьте как есть для наследования.",
	securitySev_critical: "критич.",
	securitySev_high: "высокая",
	securitySev_low: "низкая",
	securitySev_medium: "средняя",
	securitySeverity: "Важность",
	securityShowAllVideos: "Показать все видео",
	securitySourceEvents: "Исходные события",
	securitySpeedSec: "Скорость (сек):",
	securityStart: "Начало",
	securityStartLive: "Начать просмотр",
	securityStatOf: "из",
	securityStatus: "Статус",
	securityStatus_error: "Ошибка",
	securityStatus_offline: "Не в сети",
	securityStatus_online: "В сети",
	securityStatus_pending: "Ожидание",
	securityStatus_unknown: "неизв.",
	securityStopLive: "Остановить",
	securityTabActivity: "Активность",
	securityTabAlerts: "Оповещения",
	securityTabLive: "Онлайн",
	securityTabScreenshots: "Снимки",
	securityTabSessions: "Сессии",
	securityTabSettings: "Настройки",
	securityTabVideos: "Видео",
	securityTakeScreenshot: "Сделать снимок",
	securityTitle: "Заголовок",
	securityTooltipAppTrack: "Вкл./выкл. отслеживание приложений",
	securityTooltipCaptureMaster: "Вкл./выкл. захват экрана и медиа (главный переключатель)",
	securityTooltipScreenshot: "Вкл./выкл. снимки экрана",
	securityTooltipTrackingMaster:
		"Главный переключатель отслеживания приложений, веб, файлов и ввода",
	securityTooltipWebTrack: "Вкл./выкл. отслеживание доменов",
	securityTopRiskyDevices: "Наиболее рискованные устройства",
	securityTracking: "Отслеживание",
	securityTrackingEnabledMaster: "Отслеживание включено (главный)",
	securityTrackingMasterSwitch: "Отслеживание включено (главный)",
	securityTrackingOffAlertBody:
		"Отслеживание активности явно отключено на устройстве, переопределяя политику.",
	securityTrackingOffAlertTitle: "Переопределение отслеживания: ВЫКЛ",
	securityTrackingWhenOffDesc: "При выкл. неактивны приложения, веб, файлы и ввод",
	securityUnassigned: "Не назначен",
	securityUnknown: "Неизвестно",
	securityUnknownDevice: "Неизвестное устройство",
	securityUsePolicyDefault: "По умолчанию политики",
	securityUser: "Пользователь",
	securityUserLoggedIn: "Сессия активна",
	securityVideoOffAlertBody:
		"Видеозапись явно отключена на устройстве. Записи по оповещениям не выполняются, даже если политика разрешает.",
	securityVideoOffAlertTitle: "Переопределение видео: ВЫКЛ",
	securityVideoOptionsBlank: "Параметры видео (пусто = по политике)",
	securityVideoPlayAllHint:
		"Воспроизвести все от выбранного клипа к более старым; при конце страницы загружается следующая.",
	securityVideoRecording: "Видеозапись",
	securityVideoSegments: "Видеофрагменты",
	securityVideoSegmentsCount: "Видеофрагменты",
	securityViewDetail: "Подробнее",
	securityWebDomainTracking: "Домены веб",
	securityWebPollSeconds: "Опрос веб-истории (сек)",
	securityWebTracking: "Веб",
	securityWebsiteVisitsToday: "Посещения сайтов сегодня",
	securityWhen: "Когда",
	selectAlbum: "Выберите альбом",
	selectAll: "Выбрать все",
	selectArtist: "Выберите артиста",
	selectBoard: "Выберите доску",
	selectCategory: "Выберите категорию",
	selectChatPartner: "Выберите партнера для чата",
	selectClosedDate: "Выберите дату закрытия",
	selectDate: "Выберите дату",
	selectDays: "Выберите дни",
	selectDomain: "Выберите домен",
	selectEmployee: "Выберите сотрудника",
	selectFiles: "Выберите файлы",
	selectGroup: "Выберите группу",
	selectOpenedDate: "Выберите дату открытия",
	selectParentDepartment: "Выберите родительский отдел",
	selectParentUser: "Выберите родительского пользователя",
	selectPeriod: "Выберите период",
	selectPlatformToManageAndNavigate: "Выберите платформу для управления и навигации",
	selectPlaylist: "Выберите плейлист",
	selectProduct: "Выберите продукт",
	selectSomething: "Выберите что-нибудь",
	selectUsers: "Выберите пользователей",
	selectedSteps: "Выбранные шаги",
	selectedUsers: "Выбранные пользователи",
	seleteSelected: "Выбрать выбранные",
	send: "Отправить",
	sent: "Отправленно",
	seoDesc: "SEO Описание",
	servicesAndPrices: "Услуги и цены",
	setCostOfBuildingPermit: "Установить стоимость разрешения на строительство",
	setDayOff: "Установить выходной",
	settings: "Настройки",
	shiftSchedule: "График смен",
	showAllSteps: "Показать все шаги",
	showHistory: "Показать историю",
	showProjectDetails: "Показать детали проекта",
	showTableColumnFilters: "Показать фильтры столбцов",
	showTimeline: "Показать временную шкалу",
	showing: "Показано",
	shuffle: "Перемешать",
	shuffleEnabled: "Перемешивание включено",
	shuffleOverride: "Переопределение перемешивания",
	shuffleOverrideDesc: "Описание переопределения перемешивания",
	shuffleOverrideValue: "Значение переопределения перемешивания",
	sickLeave: "Больничный",
	sickLeaveDays: "Дни больничного",
	signIn: "Войти",
	signUp: "Зарегистрироваться",
	size: "Размер",
	slider: "Слайдер",
	small: "маленький",
	smb: "Папки сервера",
	socialAmount: "Сумма социального платежа",
	socialCardImages: "Изображения социальной карты",
	socialCart: "Социальная карта",
	socialNetworkLink: "Ссылка на социальную сеть",
	socialRate: "Ставка социального платежа",
	software: "Программное обеспечение",
	softwareSkills: "Навыки работы с ПО",
	somethingWentWrong: "Что-то пошло не так",
	somethingWentWrongInCreatingSteps:
		"Что-то пошло не так при создании шагов! Пожалуйста, попробуйте еще раз",
	sortBy: "Сортировать по",
	source: "Источник",
	sourceTypeEntity: "Из базы (сущность)",
	sourceTypeManual: "Ручной список",
	special: "Специальный",
	specialItems: "Специальные товары",
	speed: "скорость",
	starred: "Отмеченные",
	starredMessages: "Избранные сообщения",
	start: "Начать",
	startCall: "Начать звонок",
	startDate: "Дата начала",
	startDateShort: "Дата начала",
	startRecording: "Начать запись",
	startTime: "Время начала",
	startVideoCall: "Начать видеозвонок",
	starts: "Начинается",
	state: "Штат",
	states: "Штаты",
	status: "Статус",
	visibility: "Видимость",
	statusUpdate: "Обновление статуса",
	stayAnonymous: "Оставаться анонимным",
	step: "Шаг",
	stepIsNotStartedYet: "Шаг еще не начат",
	stepStatus: "Статус шага",
	stepStatusChangedByUser: "Статус шага изменен пользователем",
	steps: "Шаги",
	stepsLeft: "Осталось шагов",
	stillInOffice: "Всё ещё в офисе",
	stockAndProductOverview: "Обзор склада и товаров",
	stop: "Стоп",
	stopRecording: "Остановить запись",
	stopped: "Остановлено",
	streamDJ: "DJ радио",
	streamStatistics: "Статистика потоков",
	streaming: "Стриминг",
	streamsWithShuffle: "потоки с включенным перемешиванием",
	street: "Улица",
	subDesc: "Под описание",
	submit: "Отправить",
	submittedProjects: "Отправленные проекты",
	subscription: "Подписка",
	subscriptions: "Подписки",
	substation: "Подстанция",
	substationNumber: "Номер подстанции",
	subtasks: "Подзадачи",
	subtasksPlaceholder: "Enter each subtask on a new line",
	subtitle: "Подзаголовок",
	success: "Успех",
	suffix: "Суффикс",
	sun: "Воскресенье",
	support: "Поддержка",
	supportText: "По всем вопросам пишите",
	switch: "Коммутатор",
	switchers: "Коммутаторы",
	switches: "Принтеры",
	syncedFromGoogleContacts: "Синхронизировано из Google Контактов",
	systemSettings: "Настройки системы",
	table: "Таблица",
	tag: "Тег",
	tags: "Теги",
	takeMeHome: "Вернуться на главную",
	taskCreatedSuccessfully: "Задача успешно создана",
	taskCreatedSuccessfullyDescription: "Задача успешно создана",
	taskDescription: "Описание задачи",
	taskMoved: "Задача перемещена",
	taskMovedDescription: "Задача перемещена в новую категорию",
	taskStatusDistribution: "Распределение статусов задач",
	taskTitle: "Заголовок задачи",
	tasksAssigned: "Назначенные задачи",
	taxCode: "Налоговый код",
	taxNote: "Налог",
	taxes: "Налоги",
	technicalFilesUrl: "URL Технические файлы",
	telegram: "Телеграм",
	text: "Текст",
	theConstructionDepPrice: "Стоимость строительного отдела",
	theNumberOfAct: "Количество актов",
	thePriceOfProject: "Стоимость проекта",
	themePickerLabel: "Тема",
	thereIsNoResponsible: "Ответственного нет",
	thisMonth: "в этом месяце",
	thu: "Четверг",
	ticket: "Билет",
	ticketClosed: "заявка закрыта",
	ticketCreateSaveDisabledHint:
		"Выберите домен, группу проблем (если используется), проблему, затем заполните обязательные связанные поля перед сохранением.",
	ticketDashboard: "Панель управления билетами",
	ticketDomain: "Домен",
	ticketDomainsMenu: "Домены тикетов",
	ticketHierarchyAddProblem: "Добавить проблему",
	ticketHierarchyAddProblemGroup: "Добавить группу проблем",
	ticketHierarchyAddRelatedList: "Добавить связанный список",
	ticketHierarchyAddTicket: "Добавить тикет",
	ticketHierarchyAddTicketDomain: "Добавить домен",
	ticketHierarchyAddTicketHint: "Откроется создание тикета с выбранным доменом.",
	ticketHierarchyGroupsInDomain: "Группы проблем в этом домене",
	ticketHierarchyNoneYet: "Пока нет — нажмите кнопку выше.",
	ticketHierarchyProblemsInGroup: "Проблемы в этой группе",
	ticketHierarchyProblemsLinkedToList: "Проблемы, использующие этот список",
	ticketRelatedLists: "Связанные списки",
	ticketRelatedListsMenu: "Определения связанных списков",
	ticketSystemOverview: "Обзор производительности и метрик системы билетов",
	ticketTitle: "Заголовок",
	ticketType: "Тип",
	ticketTypeDomainsHint:
		"Оставьте пустым, чтобы тип был доступен во всех доменах. Выберите один или несколько доменов, чтобы показывать тип только в них.",
	ticketTypeDomainsListAll: "Все домены",
	ticketNoResponsibleUsers: "Нет ответственных пользователей",
	ticketReminderLeadMinutes: "Время напоминания (минуты)",
	ticketReminderLeadMinutesPlaceholder: "Минут до срока",
	deadlineTime: "Время срока",
	remindBefore: "Напомнить за",
	ticketAutoClose: "Автозакрытие",
	ticketAutoCloseAfter: "Автозакрытие через",
	ticketAutoCloseAfterHours: "Автозакрытие решенных тикетов через часы",
	ticketAutoCloseAfterHoursHint:
		"Укажите 0, чтобы отключить автоматическое закрытие решенных тикетов.",
	ticketSettingsLoadFailed: "Не удалось загрузить настройки тикетов",
	ticketSettingsPageSubtitle: "Управление глобальными настройками рабочего процесса тикетов.",
	ticketSettingsPageTitle: "Настройки тикетов",
	ticketSettingsReadOnly:
		"Вы можете просматривать эту настройку, но изменять ее могут только администраторы тикетов.",
	ticketSettingsSaveFailed: "Не удалось сохранить настройки тикетов",
	ticketSettingsSaved: "Настройки тикетов сохранены",
	ticketStatus_sent: "Отправлен",
	ticketStatus_in_process: "В обработке",
	ticketStatus_resolved_rejected: "Отклонён",
	ticketStatus_resolved_approved: "Одобрен",
	ticketStatus_moved_next: "Передан далее",
	ticketStatus_moved_prev: "Возвращён назад",
	ticketStatus_closed: "Закрыт",
	ticketStatus_not_accepted: "Не принят",
	ticketAction_start: "Начать обработку",
	ticketAction_next: "Следующий шаг",
	ticketAction_prev: "Предыдущий шаг",
	ticketAction_approve: "Одобрить",
	ticketAction_reject: "Отклонить",
	ticketAction_close: "Закрыть тикет",
	ticketAction_cancel: "Отменить тикет",
	ticketAction_comment: "Комментарий",
	cancelTicket: "Отменить тикет",
	ticketCancelReason: "Причина отмены",
	ticketCancelComment: "Дополнительный комментарий",
	ticketCancelCommentPlaceholder: "Добавьте детали для автора при необходимости",
	ticketCancelWarning:
		"Тикет будет помечен как не принятый и закрыт. Если помощь всё ещё нужна, автор должен создать новый тикет.",
	ticketNotAccepted: "Тикет не принят",
	ticketStepStatus_pending: "Ожидание",
	ticketStepStatus_active: "Активен",
	ticketStepStatus_completed: "Завершён",
	ticketStepStatus_approved: "Одобрен",
	ticketStepStatus_rejected: "Отклонён",
	ticketStepStatus_closed: "Закрыт",
	ticketStepStatus_cancelled: "Отменён",
	ticketFieldVisibility: "Видимость полей тикета",
	dateMode: "Режим даты",
	dateModesSingle: "Одна дата",
	dateModesInterval: "Интервал дат",
	tickets: "Билеты",
	ticketsByDepartment: "Билеты по отделам",
	ticketsByImportance: "Билеты по приоритету",
	ticketsByProblem: "Билеты по типу проблемы",
	ticketsByStatus: "Билеты по статусу",
	ticketsOverTime: "Билеты по времени",
	timAgreement: "TIM согласование",
	timDelays: "Задержки TIM",
	timSentProjects: "Проекты отправленные в TIM",
	time: "Время",
	timeBasedScheduling: "Планирование на основе времени",
	timeOff: "Отпуск",
	timeRange: "Временной диапазон",
	timeToClose: "время до закрытия билета",
	timeToFirstResponse: "время до первого ответа",
	timeline: "Лента времени",
	timestamp: "Метка времени",
	timezone: "Часовой пояс",
	title: "Заголовок",
	to: "До",
	toChat: "В чат",
	toDo: "Сделать",
	today: "Сегодня",
	todaysSales: "Продажи за сегодня",
	todo: "Задачи",
	todoBoard: "Доска",
	todoBoards: "Доски",
	todoCategories: "Категории",
	todoCategory: "Категория",
	todoLabel: "Метка",
	todoLabels: "Метки",
	todoTag: "Тег",
	todoTags: "Теги",
	todoTask: "Задача",
	todoTasks: "Задачи",
	toggles: "Переключатели",
	top: "Топ",
	topCustomers: "Топ клиентов",
	topProducts: "Топ товаров",
	total: "Всего",
	totalActiveTasks: "Всего активных задач",
	totalArtists: "Всего исполнителей",
	totalChats: "Всего чатов",
	totalClients: "Всего клиентов",
	totalCoins: "Всего монет",
	totalContent: "Всего контента",
	totalCustomers: "Всего клиентов",
	totalDeductions: "Всего удержаний",
	totalDuration: "Общая длительность",
	totalGroups: "всего групп",
	totalHours: "Всего часов",
	missingDays: "Пропущенные дни",
	missingHours: "Пропущенные часы",
	scheduled: "По графику",
	totalHoursWorked: "Всего отработанных часов",
	totalInTrash: "Всего в корзине",
	totalMessages: "Всего сообщений",
	totalOTHours: "Всего OT часов",
	totalOrders: "Всего заказов",
	totalOvertime: "Общее количество сверхурочных",
	totalPlaylists: "Всего плейлистов",
	totalPrice: "Общая цена",
	totalProducts: "Всего товаров",
	totalRevenue: "Общий доход",
	totalTickets: "Всего билетов",
	totalTracks: "Всего треков",
	totalUses: "Всего использований",
	totalValue: "Общая стоимость",
	track: "Трек",
	trackPlaylist: "Плейлист треков",
	tracks: "Треки",
	tracksByArtist: "Треки по исполнителям",
	transportAllowance: "Транспортная компенсация",
	trash: "Корзина",
	trashAutoDeleteWarning: "Предупреждение о автоматическом удалении корзины",
	trashEmptied: "Корзина очищена",
	trashedOn: "Удалено",
	tryAgain: "Попробовать снова",
	tue: "Вторник",
	type: "Тип",
	uncoveredInterval: "Непокрытый интервал",
	undefined: "Не определено",
	undo: "Отменить",
	university: "Университет",
	universityDegree: "Университетская степень",
	universityDepartment: "Факультет университета",
	unjustifiedAbsence: "Неуважительное отсутствие",
	unknown: "Неизвестно",
	unknownArtist: "Неизвестный исполнитель",
	unnamed: "Без названия",
	unnamedClient: "Клиент без имени",
	unnamedTrack: "Трек без названия",
	unpaid: "Без оплаты",
	unreadMessages: "Непрочитанные сообщения",
	unresolvedMissingIntervals: "Непокрытые интервалы — расчёт зарплаты может быть неточным",
	upcomingBirthdays: "Предстоящие дни рождения",
	update: "Обновить",
	updatedAt: "Обновлено",
	updates: "Обновления",
	upload: "Загрузить",
	uploadDate: "Дата загрузки",
	cancelUpload: "Отменить загрузку",
	uploadCancelled: "Загрузка отменена",
	uploadCancelledMessage: "Загрузка была остановлена.",
	uploading: "Загрузка",
	uploads: "Загрузки",
	uptime: "Время работы",
	urgent: "Срочный",
	used: "Использован",
	usedCount: "Количество использований",
	usedVacation: "Использованный отпуск",
	user: "Пользователь",
	userArchive: "Архив пользователя",
	userDashboard: "Панель управления пользователем",
	userDeleted: "удалено",
	userEntered: "Пользователь вошел",
	userProfile: "Профиль пользователя",
	userPayrollCalcUsesAttendance:
		"Этот расчёт использует сводку посещаемости и отпусков за {monthKey}, затем применяет действующие налоговые правила из настроек HR.",
	userUpdated: "обновлено",
	userVisited: "Пользователь посетил",
	username: "Имя пользователя",
	users: "Кадры",
	vacationBalance: "Остаток отпуска",
	vacationDaysForPeriod: "Дни отпуска за выбранный период",
	vacationInterval: "Период отпуска",
	vacationPay: "Отпускные",
	value: "Значение",
	version: "Версия",
	viber: "Вайбер",
	video: "Видео",
	view: "Просмотр",
	viewAll: "Просмотр всех",
	viewDetails: "Просмотреть детали",
	viewMore: "Посмотреть больше",
	viewProject: "Просмотр проекта",
	viewSteps: "Просмотр шагов",
	viewTrash: "Просмотр корзины",
	village: "Деревня",
	villages: "Список деревень",
	visitation: "Визитация",
	visitationDeadline: "Срок рассмотрения",
	visitationDelays: "Задержки посещения",
	voltage: "Напряжение",
	voltageLevel: "Уровень напряжения",
	volumes: "Объемы",
	voluntaryPensionAmount: "Сумма добровольной пенсии",
	voluntaryPensionRate: "Ставка добровольной пенсии (%)",
	vsPreviousPeriod: "по сравнению с предыдущим периодом",
	warning: "Предупреждение",
	warrantyDesc: "Описание гарантии",
	warrantyEnd: "Конец гарантии",
	warrantyProvider: "Поставщик гарантии",
	warrantyStart: "Начало гарантии",
	watchers: "Наблюдатели",
	weatherAriaYerevanForecast: "Прогноз погоды в Ереване",
	weatherCityYerevan: "Ереван",
	weatherClear: "Ясно",
	weatherCloudy: "Облачно",
	weatherDrizzle: "Морось",
	weatherFog: "Туман",
	weatherForecastUnavailable: "Прогноз недоступен",
	weatherHeadingYerevan: "Погода в Ереване",
	weatherHumidity: "Влажность",
	weatherLoadingShort: "Погода",
	weatherNextHours: "Ближайшие часы",
	weatherPartlyCloudy: "Переменная облачность",
	weatherPrecipUnit: "мм",
	weatherRain: "Дождь",
	weatherSnow: "Снег",
	weatherTempUnit: "°C",
	weatherThunderstorm: "Гроза",
	weatherUnknown: "Прогноз",
	weatherWind: "Ветер",
	weatherWindUnit: "км/ч",
	wed: "Среда",
	weekly: "Еженедельно",
	whatToDo: "Что делать",
	whatToDoLink: "Что делать",
	whatsapp: "WhatsApp",
	withAttachments: "С вложениями",
	withCoins: "С монетами",
	withFavorites: "С избранным",
	workDays: "Рабочие дни",
	workInformation: "Сведения о работе",
	workTime: "Рабочее время",
	workedDays: "Отработанные дни",
	workedHours: "Отработанные часы",
	working: "Работает",
	workingDays: "Рабочие дни",
	workingHoursByDay: "Рабочие часы по дням",
	workingMinutes: "Рабочие минуты",
	workingState: "Состояние работы",
	workingStatus: "Рабочий статус",
	write: "Написать",
	writeUsIfThereAreAnyQuestions: "Напишите нам, если у вас есть вопросы",
	writingContent: "Написание контента",
	writingNumber: "Написание номера",
	yes: "Да",
	yesNextStep: "Да, перейдите к следующему шагу",
	yesPreviousStep: "Да, вернитесь к предыдущему шагу",
	youCannotRevertThisAction: "Вы не можете вернуть это действие!",
	youWontBeAbleToRevert: "Вы не сможете это отменить!",
	yourFileHasBeenDeleted: "Ваш файл был удален.",
	yourFileHasBeenNotSaved: "Ваш файл не был сохранен.",
	yourFileHasBeenSaved: "Ваш файл был сохранен.",
	zipCode: "Почтовый индекс",
	zipCodes: "Почтовые индексы",
	vacationIntervalNoDeduction: "Отпуск не списывается в нерабочие дни",
	knowledgeDashboardLoadFailed: "Не удалось загрузить панель",
	knowledgeArticlesLoadFailed: "Не удалось загрузить статьи",
	knowledgeBase: "База знаний",
	knowledgeCreate: "Создать",
	knowledgeRunAutoDocs: "Запустить автодокументацию",
	knowledgeTotalArticles: "Всего статей",
	knowledgePublished: "Опубликовано",
	knowledgeDrafts: "Черновики",
	knowledgeAutoGenerated: "Автосоздано",
	knowledgeLatestUpdatedArticles: "Последние обновленные статьи",
	knowledgeArticles: "Статьи",
	knowledgeNewArticle: "Новая статья",
	knowledgeFilterArticles: "Фильтр статей",
	knowledgeCategories: "Категории",
	knowledgeParentCategory: "Родительская категория",
	knowledgeIcon: "Иконка",
	knowledgeColor: "Цвет",
	knowledgeSortOrder: "Порядок сортировки",
	knowledgeCategorySaved: "Категория сохранена",
	knowledgeCategoryDeleted: "Категория удалена",
	knowledgeSearch: "Поиск",
	knowledgeSearchArticles: "Поиск статей",
	knowledgePath: "Путь",
	knowledgeAutoGeneratedDocs: "Автосозданные документы",
	knowledgeSingleRoute: "Один маршрут",
	knowledgeNoScreenshots: "Без снимков экрана",
	knowledgeGenerateDocumentation: "Создать документацию",
	knowledgeImportGeneratedDocs: "Импортировать документы",
	knowledgeDocumentationGenerationStarted: "Создание документации запущено",
	knowledgeImported: "Импортировано",
	knowledgeGeneratedDocsImported: "Импортировано документов: {count}",
	knowledgeStarted: "Начато",
	knowledgeFinished: "Завершено",
	knowledgeRun: "Запуск",
	knowledgeOutput: "Вывод",
	knowledgeStatus_draft: "Черновик",
	knowledgeStatus_published: "Опубликовано",
	knowledgeStatus_archived: "В архиве",
	knowledgeVisibility_public: "Публично",
	knowledgeVisibility_private: "Приватно",
	knowledgeVisibility_company: "Компания",
	knowledgeRunStatus_idle: "ожидание",
	knowledgeRunStatus_running: "выполняется",
	knowledgeRunStatus_completed: "завершено",
	knowledgeRunStatus_failed: "ошибка",
	meetings: "Встречи",
	meetingsListSubtitle: "Запланированные комнаты с привязанными чатом APIT и календарем.",
	meetingsCreateMeeting: "Создать встречу",
	meetingsEditMeeting: "Редактировать встречу",
	meetingsCreateSubtitle: "Встреча = событие календаря + группа чата + видеокомната.",
	meetingsMeetingType: "Тип встречи",
	meetingsDate: "Дата",
	meetingsStartTime: "Время начала",
	meetingsEndTime: "Время окончания",
	meetingsTimezone: "Часовой пояс",
	meetingsVisibility: "Видимость",
	meetingsParticipants: "Участники",
	meetingsGroupsDepartments: "Группы/отделы",
	meetingsOptionalGroupIds: "Необязательные ID групп",
	meetingsLocation: "Место",
	meetingsReminderTime: "Время напоминания",
	meetingsMinutesShort: "мин",
	meetingsAgenda: "Повестка",
	meetingsAgendaPlaceholder: "Начало\nОбзор дизайна\nСледующие шаги",
	meetingsRecordingEnabled: "Запись включена",
	meetingsAllowJoinBeforeHost: "Разрешить вход до организатора",
	meetingsMuteUsersOnEntry: "Отключать микрофон при входе",
	meetingsAllowScreenSharing: "Разрешить демонстрацию экрана",
	meetingsSaveAsDraft: "Сохранить как черновик",
	meetingsSaveMeeting: "Сохранить встречу",
	meetingsCreateAndNotifyUsers: "Создать и уведомить пользователей",
	meetingsSaved: "Встреча сохранена",
	meetingsSaveFailed: "Не удалось сохранить встречу",
	meetingsJoin: "Войти",
	meetingsOpenChat: "Открыть чат",
	meetingsParticipantsCount: "Участников: {count}",
	meetingsType_video: "Видео",
	meetingsType_audio: "Аудио",
	meetingsType_in_person: "Очно",
	meetingsType_hybrid: "Гибридно",
	meetingsVisibility_private: "Приватно",
	meetingsVisibility_company: "Компания",
	meetingsVisibility_department: "Отдел",
	meetingsStatus_draft: "Черновик",
	meetingsStatus_scheduled: "Запланировано",
	meetingsStatus_live: "В эфире",
	meetingsStatus_ended: "Завершено",
	meetingsStatus_cancelled: "Отменено",
	aiSettingsAction: "Действие",
	aiSettingsAllowedModules: "Разрешённые модули",
	aiSettingsApprove: "Одобрить",
	aiSettingsApprovalFailed: "Ошибка одобрения",
	aiSettingsDisabled: "Отключено",
	aiSettingsEnabled: "Включено",
	aiSettingsEvent: "Событие",
	aiSettingsLogs: "Журналы",
	aiSettingsLoadFailed: "Не удалось загрузить параметры AI",
	aiSettingsNoGateway: "Шлюз не настроен",
	aiSettingsNoPendingApprovals: "Нет ожидающих одобрений",
	aiSettingsNoLogs: "Нет журналов",
	aiSettingsNoPermission: "Отсутствует разрешение администратора AI.",
	aiSettingsPendingApprovals: "Ожидающие одобрения",
	aiSettingsReject: "Отклонить",
	aiSettingsRejectFailed: "Ошибка отклонения",
	aiSettingsRefresh: "Обновить",
	aiSettingsRequireApproval: "Требовать одобрения",
	aiSettingsStatus: "Статус",
	aiSettingsTime: "Время",
	aiSettingsTitle: "Параметры AI",
	aiSettingsTool: "Инструмент",
	aiSettingsUser: "Пользователь",
	aiSettingsUpdateFailed: "Ошибка обновления параметров",
	aiSettingsDefaultMode: "Режим по умолчанию",
	aiSettingsReadOnly: "только чтение",
	aiSettingsApprovalRequired: "требуется одобрение",
	aiSettingsAdminOnly: "только администраторы",
	financeActiveCurrencies: "{count} активных валют",
	financeAddCurrency: "Добавить валюту",
	financeCurrencyCode: "Код",
	financeCurrencyCoefficient: "Коэффициент",
	financeCurrencyDefault: "По умолчанию",
	financeCurrencyName: "Имя",
	financeCurrencySymbol: "Символ",
	financeCurrencyUse: "Использовать",
	financeLoadFailed: "Не удалось загрузить параметры финансов",
	financeSaveSettings: "Сохранить параметры",
	financeSavedMessage: "Параметры финансов сохранены",
	financeSaveFailed: "Не удалось сохранить параметры финансов",
	financeSelectedDefault: "Выбранная по умолчанию:",
	financeSettingsSubtitle:
		"Валюты здесь управляют отображением денег по умолчанию на страницах финансов и заказов.",
	financeSettingsTitle: "Параметры финансов",
	hrAccrualCoeffPreview: "Предпросмотр коэффициента",
	hrAccrualCoeffPreviewLine1:
		"{accrualWorkedHours} отработанных часов → {accrualVacationHours} часов отпуска",
	hrAccrualCoeffPreviewLine2: "Часы отпуска, заработанные за отработанный час: {hourlyCoefficient}",
	hrAccrualCoeffStoredNote:
		"Задняя часть хранит это начисление в минутах, чтобы расчёт зарплаты и балансы отпуска могли использовать значения части дня без погрешности округления.",
	hrAccrualFixedYearly: "Фиксированные годовые дни отпуска",
	hrAccrualFixedYearlyDesc:
		"Начисляйте установленное количество дней отпуска в течение года, используя существующее ежедневное или ежемесячное расписание.",
	hrAccrualModelChoice:
		"Выберите одну активную модель начисления. Годовые дни и коэффициент отработанных часов используют логику ИЛИ, а не объединение.",
	hrAccrualSuffixMin: "мин",
	hrAccrualVacationMinutesEarned: "Заработанные минуты отпуска",
	hrAccrualVacationMinutesEarnedDesc:
		"Количество минут отпуска, начисляемых на единицу времени работы.",
	hrAccrualWorkBreak: "Рабочий перерыв",
	hrAccrualWorkBreakDesc:
		"Ежедневные непокрытые минуты, классифицируемые как перерывы в интервалах отсутствия в офисе.",
	hrAccrualWorkedHoursModel: "Отработанные часы на часы отпуска",
	hrAccrualWorkedHoursModelDesc:
		"Начисляйте отпуск на основе фактического отработанного времени, используя настраиваемый коэффициент отработанных часов.",
	hrAccrualWorkedMinutesUnit: "Единица отработанных минут",
	hrAccrualWorkedMinutesUnitDesc: "Сколько минут работы должно создать единицу начисления.",
	hrWeekdayFri: "Пт",
	hrWeekdayMon: "Пн",
	hrWeekdaySat: "Сб",
	hrWeekdaySun: "Вс",
	hrWeekdayThu: "Чт",
	hrWeekdayTue: "Вт",
	hrWeekdayWed: "Ср",
	knowledgeSettingsAiEnabled: "AI включен",
	knowledgeSettingsAiModel: "Модель AI",
	knowledgeSettingsAiProvider: "Поставщик AI",
	knowledgeSettingsEnableAutoDocs: "Включить автоматическую документацию",
	knowledgeSettingsLanguage: "Язык по умолчанию",
	knowledgeSettingsMaxSizeMb: "Максимальный размер статьи МБ",
	knowledgeSettingsRootCategory: "Корневая категория автодокументации",
	knowledgeSettingsSaveSettings: "Сохранить параметры",
	knowledgeSettingsSaved: "Параметры базы знаний обновлены",
	knowledgeSettingsTitle: "Параметры",
	knowledgeSettingsUploadExt: "Разрешённые расширения загрузки",
	knowledgeSettingsVisibility: "Видимость по умолчанию",
	nvrAddFromList: "Добавить камеры из списка",
	nvrCamerasList: "Список камер",
	nvrChannel: "Канал",
	nvrChannelId: "ID",
	nvrChannelName: "Имя",
	nvrChannelsTitle: "Каналы, зарегистрированные с этого NVR",
	nvrConnectionDesc:
		"Введите IP, порт и шаблон пути (только /.../{channel}... — как в VLC, без части rtsp://). Добавьте имя пользователя и пароль RTSP (большинству NVR они необходимы). Нажмите Сохранить, чтобы запустить автоматическое сканирование сети, или используйте Добавить камеры из путей ниже, чтобы зарегистрировать каналы без сканирования. Откройте камеру для просмотра в реальном времени; на карте офиса размещайте устройства обычным образом.",
	nvrConnectionTitle: "NVR — одно соединение для всех каналов",
	nvrDiscoveryFailed: "Обнаружение не удалось",
	nvrEnterPaths: "Введите хотя бы один канал или путь.",
	nvrFoundChannels: "Найдено {n} канал(ов).",
	nvrFullUrl: "Полный URL (канал 101 — автоматически из полей выше)",
	nvrInitError: "NVR не удалось инициализировать. Перезагрузите страницу.",
	nvrIp: "NVR IP",
	nvrIpPasswordRequired:
		"Требуются IP NVR и сохранённый пароль. Установите пароль, сохраните, и мы просканируем каналы при следующем сохранении.",
	nvrLoadFailed: "Не удалось загрузить NVR",
	nvrLiveStatus: "Статус в реальном времени",
	nvrManualDesc:
		"Когда автоматическое сканирование не удаётся (например, API не может достичь NVR), перечислите каналы здесь. Используйте по одному на строку: номеры каналов типа 101, 201, путь типа /Streaming/Channels/102 или полный URL rtsp://. Пути объединяются с вашим шаблоном пути RTSP при вводе только номеров. Сначала сохраните NVR, если вы изменили IP или шаблон, затем добавьте строки и нажмите кнопку.",
	nvrManualTitle: "Добавить камеры из путей RTSP (без сканирования сервера)",
	nvrNotReady: "NVR не готов. Перезагрузите страницу.",
	nvrNotReadyShort: "NVR не готов.",
	nvrNotWorking: "Не работает",
	nvrOfficeMap: "Карта офиса",
	nvrOffline: "Оффлайн",
	nvrOnline: "Онлайн",
	nvrPasswordChangeNote: "Измените и сохраните, чтобы обновить сохранённый пароль.",
	nvrPasswordLeaveBlank: "Оставьте пусто, чтобы сохранить текущий пароль",
	nvrPasswordRequired:
		"Требуется для большинства NVR для обнаружения каналов и потоковой передачи.",
	nvrPasswordStoredLeaveBlank:
		"Пароль сохранён; оставьте пусто, чтобы сохранить его, или введите новый.",
	nvrRegisterFailed: "Не удалось зарегистрировать пути",
	nvrRegisteredCameras: "Зарегистрировано {n} камер(ы).",
	nvrRtspPassword: "Пароль RTSP",
	nvrRtspPathTemplate: "Шаблон пути RTSP",
	nvrRtspPathTemplateHint:
		"Вводите только путь с {channel}. Не вводите полную строку rtsp:// здесь.",
	nvrRtspUsername: "Имя пользователя RTSP",
	nvrScanChannels: "Просканировать каналы снова",
	nvrScanHint: "Это сохраняет текущие поля соединения, затем сканирует.",
	nvrWorkingState: "Рабочее состояние",
	nvrWorking: "Работает",
	nvrGridEmpty: "На этот NVR ещё не привязаны каналы. Запустите обнаружение на странице NVR.",
	nvrGridLoadFailed: "Не удалось загрузить каналы",
	nvrGridLoading: "Загрузка каналов…",
	nvrGridStreamFailed: "Не удалось начать",
	nvrGridStreamStopped: "Поток остановлен",
	nvrGridTitle: "Все каналы NVR",
	securityRecordingActiveDays: "Активные дни",
	securityRecordingDesc:
		"Включить запись на стороне сервера для камер, у которых включена запись на сервере. Каждая камера также может иметь своё собственное расписание ниже.",
	securityRecordingEndTime: "Время окончания",
	securityRecordingGlobalEnable: "Включить запись глобально",
	securityRecordingGlobalEnableDesc:
		"Главный переключатель — отключение этого останавливает все записи независимо от параметров для каждой камеры.",
	securityRecordingLoadFailed: "Не удалось загрузить параметры безопасности",
	securityRecordingLocalFs: "Локальная файловая система",
	securityRecordingLocalPathNote:
		"Локальный путь настраивается через переменную окружения SECURITY_RECORDING_LOCAL_PATH на сервере.",
	securityRecordingNoScheduleNote:
		"Без расписания — камеры будут записываться 24/7 при включении записи на сервере.",
	securityRecordingRetentionDays: "Хранение (дни)",
	securityRecordingRetentionDesc: "Сегменты старше этого будут удалены автоматически.",
	securityRecordingS3: "S3 / совместимое хранилище объектов",
	securityRecordingS3Note:
		"Учётные данные S3 настраиваются через переменные окружения на сервере (AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY и т. д.).",
	securityRecordingSaveSettings: "Сохранить параметры",
	securityRecordingSaved: "Параметры безопасности сохранены.",
	securityRecordingSaveFailed: "Не удалось сохранить параметры",
	securityRecordingScheduleDesc:
		"Это расписание применяется ко всем камерам с включённой записью на сервере, у которых нет собственного переопределения расписания для каждой камеры.",
	securityRecordingScheduleEnable:
		"Включить расписание по умолчанию (записывать только в установленные часы)",
	securityRecordingScheduleNote:
		"Запись будет выполняться в выбранные дни между этими часами. Вне этого окна запись автоматически приостанавливается.",
	securityRecordingScheduleTitle: "Расписание записи по умолчанию",
	securityRecordingSegmentLength: "Длина сегмента (минуты)",
	securityRecordingSegmentLengthDesc:
		"Это управляет тем, как часто на каждой странице камеры появляется новое видео.",
	securityRecordingStartTime: "Время начала",
	securityRecordingStorage: "Хранилище",
	securityRecordingStorageBackend: "Бэкенд хранилища",
	securityRecordingTitle: "Запись камеры на сервере",
	securitySurveillanceCameraMedia: "Медиа камеры",
	securitySurveillanceDashboard: "Панель видеонаблюдения",
	securitySurveillanceNoCameras: "Камер не найдено.",
	securitySurveillanceOffline: "Оффлайн",
	securitySurveillanceOnline: "Онлайн",
	teamWorkload: "Нагрузка команды",
	workloadTasks: "Задачи",
	workloadTickets: "Тикеты",
	workloadSteps: "Шаги",
	assignedEmployee: "Назначенный сотрудник",
	boughtDate: "Дата покупки",
	broken: "Сломан",
	depreciation: "Амортизация",
	deviceStatus: "Статус устройства",
	handoverDocument: "Акт передачи",
	maintenanceSchedule: "График обслуживания",
	qrCode: "QR-код",
	repair: "Ремонт",
	repairHistory: "История ремонтов",
	replacementDate: "Дата замены",
	retired: "Списан",
	returnDocument: "Акт возврата",
	warrantyDate: "Дата гарантии",
	noOpenWorkload: "Нет открытой нагрузки",
	attendanceTable: "Таблица посещаемости",
	filteredFrom: "отфильтровано из",
	weekend: "Выходной",
	attendanceNextRefresh: "Следующее обновление",
	refreshAttendanceDevices: "Обновить данные с устройств посещаемости",
	attendanceSyncSuccess: "Устройства посещаемости синхронизированы",
	attendanceSyncFailed: "Не удалось синхронизировать устройства посещаемости",
	// User account security / profile
	contactInformation: "Контактная информация",
	accountSecurity: "Безопасность аккаунта",
	accountStatus: "Статус аккаунта",
	accountStatusActive: "Активен",
	accountStatusLocked: "Заблокирован",
	mustChangePassword: "Нужно сменить пароль",
	lockedAt: "Заблокирован",
	passwordLastChanged: "Пароль изменён",
	accountSecurityDesc: "Текущие пароли никогда не отображаются. Используйте временный пароль или безопасную ссылку сброса, когда нужно изменить учётные данные.",
	accountSecurityHint: "Используйте «Сбросить пароль», когда нужна немедленная смена учётных данных. Используйте «Отправить ссылку сброса», когда пользователь должен сам выбрать новый пароль без показа секрета администратору.",
	lockAccount: "Заблокировать аккаунт",
	unlockAccount: "Разблокировать аккаунт",
	forcePasswordChangeAction: "Принудительная смена пароля",
	clearForcedPasswordChange: "Снять принудительную смену пароля",
	resetPassword: "Сбросить пароль",
	sendResetLink: "Отправить ссылку сброса",
	sessionVisibilityRequiresPermission: "Для просмотра сессий и устройств требуется дополнительное разрешение.",
	resetPasswordConfirmTitle: "Сбросить этот пароль?",
	resetPasswordConfirmText: "Будет создан временный пароль, и пользователь должен будет сменить его при следующем входе.",
	temporaryPasswordGenerated: "Временный пароль создан",
	temporaryPasswordShareHint: "Передавайте его только по безопасному каналу.",
	sendResetLinkConfirmTitle: "Отправить ссылку сброса пароля?",
	sendResetLinkConfirmText: "Пользователю будет отправлена одноразовая безопасная ссылка для сброса пароля.",
	passwordResetLinkSent: "Ссылка для сброса пароля отправлена.",
	lockAccountConfirmTitle: "Заблокировать этот аккаунт?",
	unlockAccountConfirmTitle: "Разблокировать этот аккаунт?",
	lockAccountConfirmText: "Пользователь не сможет войти, пока аккаунт не будет разблокирован.",
	unlockAccountConfirmText: "Пользователь снова сможет сразу войти в систему.",
	accountLockedMsg: "Аккаунт заблокирован.",
	accountUnlockedMsg: "Аккаунт разблокирован.",
	forcePasswordChangeConfirmTitle: "Требовать смену пароля при следующем входе?",
	removeForcedPasswordChangeConfirmTitle: "Снять требование смены пароля?",
	forcePasswordChangeConfirmText: "Пользователь сможет войти только для смены пароля, прежде чем пользоваться платформой.",
	removeForcedPasswordChangeConfirmText: "Пользователь сможет продолжать вход в обычном режиме.",
	forcedPasswordChangeEnabled: "Принудительная смена пароля включена.",
	forcedPasswordChangeRemoved: "Принудительная смена пароля снята.",
	securityUpdated: "Безопасность обновлена",
	securityActionFailed: "Действие безопасности не удалось",
	knownDevicesAndSessions: "Известные устройства и открытые сессии",
	knownDevicesAndSessionsDesc: "Местоположения приблизительные и обычно отражают IP, провайдера, VPN или офисный шлюз, а не точное физическое положение устройства.",
	openSessionsBadge: "{count} открыто",
	revokeOtherSessions: "Отозвать другие сессии",
	registeredDevices: "Зарегистрированные устройства",
	unknownDevice: "Неизвестное устройство",
	unknownBrowser: "Неизвестный браузер",
	unknownOs: "Неизвестная ОС",
	browserOnOs: "{browser} на {os}",
	firstSeen: "Впервые замечено",
	sessionsBadge: "{count} сессий",
	currentDevice: "Текущее устройство",
	noKnownDevices: "Известных устройств пока нет.",
	approximateLoginOrigins: "Приблизительные места входа",
	sessionDetails: "Детали сессий",
	device: "Устройство",
	network: "Сеть",
	lastActive: "Последняя активность",
	approximateLocationUnavailable: "Приблизительное местоположение недоступно",
	revoke: "Отозвать",
	noAuthSessions: "Сессии входа пока не записаны.",
	sessionOriginApproximateNote: "Данные о происхождении сессии приблизительны. Не считайте геолокацию IP точным положением устройства.",
	connectedMeansNote: "«Подключено» значит, что у браузера/приложения есть живой сокет. «Отключено» значит, что браузер закрыт или офлайн, но сохранённая сессия может оставаться действительной до выхода, отзыва или истечения срока.",
	revokeThisSessionTitle: "Отозвать эту сессию?",
	revokeThisSessionText: "Выбранное устройство/сессия будет вынуждено войти снова.",
	revokeSession: "Отозвать сессию",
	sessionRevoked: "Сессия отозвана",
	sessionRevokedSuccess: "Выбранная сессия успешно отозвана.",
	failedToRevokeSession: "Не удалось отозвать сессию",
	unableToRevokeSession: "Не удалось отозвать выбранную сессию.",
	revokeOtherSessionsTitle: "Отозвать другие сессии?",
	revokeOtherSessionsText: "Все сессии этого пользователя будут отозваны, кроме текущей, если пользователь отзывает свои устройства.",
	revokeSessions: "Отозвать сессии",
	sessionsRevoked: "Сессии отозваны",
	revokedSessionsCount: "Отозвано сессий: {count}.",
	failedToRevokeSessions: "Не удалось отозвать сессии",
	unableToRevokeSessions: "Не удалось отозвать выбранные сессии.",
	failedToLoadSessions: "Не удалось загрузить сессии",
	unableToLoadUserSessions: "Не удалось загрузить сессии пользователя.",
	sessionStatusRevoked: "Отозвана",
	sessionStatusConnected: "Подключено",
	sessionStatusDisconnected: "Отключено",
	currentSession: "Текущая",
	passwordChangeOnly: "Только смена пароля",
	faceId: "Face ID",
	passwordsNeverShownHint: "Пароли здесь не показываются. Используйте вкладку «Безопасность», чтобы заблокировать или разблокировать аккаунт, потребовать смену пароля, создать временный пароль или отправить ссылку сброса.",
	sharedFolders: "Общие папки",
	flexId: "Flex Id",
	emailNotProvided: "Email не указан",
	anonymousUser: "Анонимный пользователь",
	noMapPointsYet: "Точек на карте пока нет",
	noMapPointsYetDesc: "Местоположения сессий с приблизительными координатами пока недоступны. Backend может отслеживать устройства и сессии и без геопровайдера.",
	googleMapsKeyNotConfigured: "Ключ Google Maps не настроен",
	googleMapsKeyNotConfiguredDesc: "Задайте REACT_APP_GOOGLE_MAPS_API_KEY, чтобы показать карту сессий.",
	mapFailedToLoad: "Не удалось загрузить карту",
	mapFailedToLoadDesc: "Сейчас не удалось загрузить Google Maps.",
	approximateLocation: "Приблизительное местоположение",
	officeInventory: "Офисный инвентарь",
	officeInventoryDescription: "Учет не-IT имущества и расходных материалов, которыми компания уже владеет.",
	infrastructure: "Инфраструктура",
	inventory: "Инвентарь",
	fixedAssets: "Основные средства",
	consumables: "Расходные материалы",
	storageStock: "Склад / Запасы",
	maintenance: "Обслуживание",
	reservations: "Бронирования",
	receivePurchase: "Принять закупку",
	responsiblePerson: "Ответственное лицо",
	storageLocation: "Место хранения",
	lowStock: "Низкий запас",
	expiringSoon: "Скоро истекает",
	underMaintenance: "На обслуживании",
	assetNumber: "Инвентарный номер",
	inventoryTransaction: "Операция с инвентарем",
	allItems: "Все предметы",
	addItem: "Добавить предмет",
	importExcel: "Импорт Excel",
	exportExcel: "Экспорт Excel",
	printQrLabels: "Печать QR-этикеток",
	advancedFilters: "Расширенные фильтры",
	recentlyReceived: "Недавно получено",
	unassigned: "Не назначено",
	damaged: "Повреждено",
	inventoryType: "Тип инвентаря",
	availableQuantity: "Доступное количество",
	condition: "Состояние",
	location: "Расположение",
	noInventoryItems: "Инвентарь не найден",
	inventoryEmptyDesc: "Добавьте имущество вручную или примите утвержденную офисную закупку.",
	productPurpose: "Назначение продукта / Контекст использования",
	generalProduct: "Обычный продукт",
	officeInventoryProduct: "Офисный инвентарь",
	itAssetProduct: "IT-актив",
	serviceProduct: "Услуга",
	officeClassification: "Офисная классификация",
	inventoryCreationRules: "Правила создания инвентаря",
	defaultDestination: "Место назначения по умолчанию",
	trackingMode: "Режим учета",
	individuallyTracked: "Индивидуальный учет",
	batchTracked: "Партионный учет",
	autoCreateOnReceipt: "Автоматически создавать инвентарь после приемки",
	autoGenerateAssetNumber: "Автоматически создавать инвентарный номер",
	autoGenerateQrCode: "Автоматически создавать QR-код",
	requireSerialNumber: "Требовать серийный номер",
	requireWarranty: "Требовать сведения о гарантии",
	requireExpirationDate: "Требовать срок годности",
	requireInspection: "Требовать график проверки",
	canBecomeBookable: "Можно сделать бронируемым ресурсом",
	totalActiveRooms: "Активные комнаты",
	bookingsToday: "Бронирования сегодня",
	activeNow: "Активно сейчас",
	pendingApprovals: "Ожидают одобрения",
	officeMaintenanceDescription: "Ремонт, проверки и плановое обслуживание офисного инвентаря.",
	noMaintenanceRecords: "Записи об обслуживании не найдены.",
	settingsDescription: "Настройка категорий, нумерации, предупреждений и мест хранения.",
	rulesNumbering: "Правила и нумерация",
	requirements: "Требования",
	assetNumberFormat: "Формат инвентарного номера",
	assetNumberTokens: "Метки: {YEAR}, {SEQUENCE}, {OFFICE_CODE}, {CATEGORY_CODE}",
	qrValueFormat: "Формат значения QR",
	warrantyWarningDays: "Предупреждение о гарантии, дней",
	expirationWarningDays: "Предупреждение о сроке годности, дней",
	inspectionWarningDays: "Предупреждение о проверке, дней",
	autoCreateBookableResources: "Автоматически создавать бронируемые ресурсы по правилам продукта",
	permanentInventoryLink: "Постоянная ссылка на инвентарь",
	showQr: "Показать QR",
	downloadSvg: "Скачать SVG",
	reservedQuantity: "Зарезервированное количество",
	noBookableResource: "Этот объект имущества не является бронируемым ресурсом.",
	noMovements: "Движений пока нет.",
	disposalWarning: "История покупок и перемещений сохранится, доступный остаток будет обнулен, а связанный ресурс отключен.",
	quantityChange: "Изменение количества (+ или −)",
	issueDescription: "Описание проблемы",
	auditReasonHelp: "Предыдущее и новое значение, пользователь и время будут записаны в журнал.",
	downloadTemplate: "Скачать шаблон",
	validatePreview: "Проверить и просмотреть",
	validation: "Проверка",
	valid: "Корректно",
	selectInventoryLine: "Выберите хотя бы одну строку офисного инвентаря",
	noReceivableOfficeProducts: "В этой покупке нет доступных к приемке продуктов офисного инвентаря.",
	serialNumbersHelp: "Один серийный номер в строке (или через запятую)",
	nextInspection: "Следующая проверка",
	leaveBlankGenerate: "Оставьте пустым для автоматического создания",
	expectedMonthlyUsage: "Ожидаемый месячный расход",
	expectedUsefulLifeMonths: "Ожидаемый срок службы (месяцев)",
	warrantyDurationMonths: "Срок гарантии (месяцев)",
	maintenanceIntervalDays: "Интервал обслуживания (дней)",
	inspectionIntervalDays: "Интервал проверок (дней)",
	productPurposeHelp: "Продукт — то, что компания может купить; имущество создается только после приемки покупки.",
	safetyCompliance: "Безопасность / соответствие",
	adjust: "Корректировать",
	assign: "Назначить",
	available: "Доступно",
	bookable: "Бронируемый",
	desk: "Рабочее место",
	dispose: "Списать",
	documents: "Документы",
	expirationDate: "Срок годности",
	floor: "Этаж",
	inspection: "Проверка",
	minimumQuantity: "Минимальное количество",
	no: "Нет",
	notFound: "Не найдено",
	notes: "Примечания",
	office: "Офис",
	purchase: "Покупка",
	purchaseDate: "Дата покупки",
	reason: "Причина",
	receivedDate: "Дата приемки",
	reorderQuantity: "Количество пополнения",
	resources: "Ресурсы",
	select: "Выбрать",
	serialNumber: "Серийный номер",
	shopPurchase: "Покупка",
	stock: "Остаток",
	subcategory: "Подкатегория",
	transfer: "Переместить",
	unit: "Единица",
	viewPurchase: "Открыть покупку",
	warranty: "Гарантия",
	print: "Печать",
	selectAllInventory: "Выбрать весь инвентарь",
	chooseXlsxFile: "Выберите файл .xlsx",
	importPreviewSummary: "Строк: {total}; корректных: {valid}; с ошибками: {invalid}. Некорректные строки не будут импортированы.",
	importValidRows: "Импортировать корректные строки: {count}",
	receiptReplay: "Эта приемка уже завершена; показан исходный результат.",
	inventoryRecordsCreated: "Создано или обновлено записей инвентаря: {count}.",
	remaining: "осталось",
	assetNumbersHelp: "Один инвентарный номер в строке (или через запятую)",
	fieldIsRequired: "Поле «{field}» обязательно",
	actualVacation: "Отпуск",
	vacationPlanning: "Планирование отпуска",
	vacationPlanningPresentationHint: "Только для планирования — этот период не влияет на посещаемость, зарплату или остаток отпуска.",
	vacationPlanningSaved: "План отпуска сохранён",
	vacationPlanningRemoved: "План отпуска удалён",
	attendanceLastRefreshed: "Последнее обновление",
	quarter: "Квартал",
	year: "Год",
	currentQuarter: "Текущий квартал",
	currentYear: "Текущий год",
	chatBlockedSection: "Заблокированные контакты",
	chatBlockUserConfirm: "Заблокировать этого пользователя? Он не сможет писать вам в этом чате.",
};
